<template>
  <div class="homemain">
    <div class="home-left">
      <div class="left-top">
        <div class="top_title">
          <div class="titlebox">
            <div class="titlepoint"></div>
            AI值班日志
          </div>
          <div class="datebox">
            <div class="timebox">时间：{{ stime }} ~ {{ etime }}</div>
            <div class="realdatabox">
              <span>实时</span>
              <el-switch v-model="realtime" active-color="#3089f8" inactive-color="#5B50A9" @change="realtimechange">
              </el-switch>
            </div>

            <div @click="timetypeclick('day')" :class="timetype == 'day' ? 'dateitem dated' : 'dateitem'">
              日
            </div>
            <div @click="timetypeclick('month')" :class="timetype == 'month' ? 'dateitem dated' : 'dateitem'">
              月
            </div>
            <div @click="timetypeclick('year')" :class="timetype == 'year' ? 'dateitem dated' : 'dateitem'">
              年
            </div>
          </div>
        </div>
        <div class="tipcont" v-if="aibox.name == '晓知因'">
          <div class="tipleft">
            <div class="contitem">
              <p class="name">服务产业数</p>
              <p class="num c1">
                {{ aizblist.industryCount || 0 }}<span>个</span>
              </p>
              <!-- <div class="godetail">查看详情</div> -->
            </div>
            <div class="contitem">
              <p class="name">服务园区数</p>
              <p class="num c1">{{ aizblist.parkCount || 0 }}<span>个</span></p>
              <!-- <div class="godetail">查看详情</div> -->
            </div>
            <div class="contitem">
              <p class="name">服务企业数</p>
              <p class="num c1">
                {{ aizblist.enterpriseCount || 0 }}<span>个</span>
              </p>
              <!-- <div class="godetail">查看详情</div> -->
            </div>
            <div class="contitem">
              <p class="name">服务微信群数</p>
              <p class="num c1">13<span>个</span></p>
              <!-- <div class="godetail">查看详情</div> -->
            </div>
            <div class="contitem">
              <p class="name">总算力</p>
              <p class="num c1">{{ thisaibotcount.computility || 0 }}</p>
              <!-- <div class="godetail">查看详情</div> -->
            </div>

            <div class="contitem">
              <p class="name">用户数</p>
              <p class="num c3">3<span>个</span></p>
              <!-- <div class="godetail">查看详情</div> -->
            </div>
            <div class="contitem">
              <p class="name">新增机器人</p>
              <p class="num c3">
                {{ newaiData.robotNumber || 0 }}<span>个</span>
              </p>
              <!-- <div class="godetail">查看详情</div> -->
            </div>
            <div class="contitem">
              <p class="name">新增知识库</p>
              <p class="num c3">
                {{ newaiData.knowledgeBaseNumber || 0 }}<span>个</span>
              </p>
              <!-- <div class="godetail">查看详情</div> -->
            </div>
            <div class="contitem">
              <p class="name">问答次数</p>
              <p class="num c3">
                {{ thisaibotcount.question || 0 }}<span>个</span>
              </p>
              <!-- <div class="godetail">查看详情</div> -->
            </div>
            <div class="contitem">
              <p class="name">AI推送数</p>
              <p class="num c3">{{ thisaibotcount.num || 0 }}<span>个</span></p>
              <!-- <div class="godetail">查看详情</div> -->
            </div>

            <div class="contitem contitemo">
              <p class="onum">{{ aizblist.gboxCount || 0 }}</p>
              <p class="oname">管理GBOX总数</p>

              <!-- <div class="ogodetail">查看详情</div> -->
            </div>
            <div class="contitem contitemo">
              <p class="onum">{{ aizblist.cboxCount || 0 }}</p>
              <p class="oname">管理CBOX总数</p>

              <!-- <div class="ogodetail">查看详情</div> -->
            </div>
            <div class="contitem contitemo">
              <p class="onum">{{ aizblist.issuesCount || 0 }}</p>
              <p class="oname">设备问题总数</p>

              <!-- <div class="ogodetail">查看详情</div> -->
            </div>
            <div class="contitem contitemo">
              <p class="onum">{{ warnum || 0 }}</p>
              <p class="oname">预警推送</p>

              <!-- <div class="ogodetail">查看详情</div> -->
            </div>
          </div>
          <div class="tipright">
            <div class="contitem" ref="spacePie">
              <el-tooltip class="tip" :content="'运行状态'" placement="top">
                <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949" active-value="100"
                  inactive-value="0" @change="chartChange">
                </el-switch>
              </el-tooltip>
              <div class="pie-wrapper" v-show="value === '0'">
                <p class="name">GBOX运行状态</p>
                <div id="gboxcharts" class="barcharts"></div>
              </div>
              <div class="pie-wrapper" v-show="value === '100'">
                <p class="name">CBOX运行状态</p>
                <div id="cboxcharts" class="barcharts"></div>
              </div>
            </div>

            <div class="contitem">
              <p class="name">微信机器人在线情况</p>
              <div id="cboxcharts" class="barcharts"></div>
            </div>
          </div>
        </div>
        <div class="tipcont" v-else>
          <div class="contitem">
            <p class="name">服务产业数</p>
            <p class="num c1">
              {{ aizblist.industryCount || 0 }}<span>个</span>
            </p>
            <!-- <div class="godetail">查看详情</div> -->
          </div>
          <div class="contitem">
            <p class="name">服务园区数</p>
            <p class="num c1">{{ aizblist.parkCount || 0 }}<span>个</span></p>
            <!-- <div class="godetail">查看详情</div> -->
          </div>
          <div class="contitem">
            <p class="name">服务企业数</p>
            <p class="num c2">
              {{ aizblist.enterpriseCount || 0 }}<span>个</span>
            </p>
            <!-- <div class="godetail">查看详情</div> -->
          </div>
          <div class="contitem">
            <p class="name">服务微信群数</p>
            <p class="num c2">13<span>个</span></p>
            <!-- <div class="godetail">查看详情</div> -->
          </div>
          <div class="contitem">
            <p class="name">AI推送数</p>
            <p class="num c3">{{ thisaibotcount.num || 0 }}<span>个</span></p>
            <!-- <div class="godetail">查看详情</div> -->
          </div>
          <div class="contitem">
            <p class="name">问答次数</p>
            <p class="num c3">
              {{ thisaibotcount.question || 0 }}<span>个</span>
            </p>
            <!-- <div class="godetail">查看详情</div> -->
          </div>
          <div class="contitem">
            <p class="name">用户数</p>
            <p class="num c3">3<span>个</span></p>
            <!-- <div class="godetail">查看详情</div> -->
          </div>
        </div>
      </div>
      <div class="left_bottom">
        <div class="bottom_item xzy">
          <div class="bottom_title">
            <div class="titlebox">
              <div class="titlepoint"></div>
              最热机器人
            </div>
          </div>
          <div class="botcontent">
            <div class="aibothead">
              <div class="head">
                <img src="@/assets/images/zqzs/xzy.png" />
              </div>
              <div class="name">
                <div class="nametxt">{{ hotai.source }}</div>
                <div>AI智控机器人</div>
              </div>
            </div>
            <div class="aibotcont">
              <div class="contitem">
                <div class="name">
                  <div class="namepoint"></div>
                  问答次数
                </div>
                <div class="num">
                  {{ parseInt(hotai.num * 12.34) }}<span>次</span>
                </div>
              </div>
              <div class="contitem">
                <div class="name">
                  <div class="namepoint"></div>
                  AI热搜
                </div>
                <div class="num">
                  {{ parseInt(hotai.question * 12.34) }}<span>次</span>
                </div>
              </div>
              <div class="contitem">
                <div class="name">
                  <div class="namepoint"></div>
                  算力
                </div>
                <div class="num">
                  {{ hotai.computility
                  }}<span style="font-size: 12px">TFLOPS</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_item hot">
          <div class="bottom_title">
            <div class="titlebox">
              <div class="titlepoint"></div>
              AI热搜
            </div>
          </div>
          <div class="botcontent">
            <div class="hotitem" v-for="(item, i) in aicount.questions" :key="i">
              <div class="l1" v-if="i < 3">{{ i + 1 }}</div>
              <div class="l1e" v-else>{{ i + 1 }}</div>
              <div class="name">{{ item.text }}</div>
              <div class="ratio">{{ item.num }}</div>
              <div class="u-d">
                <svg t="1717505777798" v-if="i < 3" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="2692" width="32" height="32">
                  <path
                    d="M529.143158 7.436293l347.212925 397.874796a21.748783 21.748783 0 0 1-16.375554 36.077393h-170.66398a21.492915 21.492915 0 0 0-21.492915 18.678367c-12.793402 92.624229-90.065549 502.268955-455.95684 562.909679a21.748783 21.748783 0 0 1-17.654895-38.380206c62.687669-49.126663 144.56544-144.309572 167.593564-313.694212a1571.285609 1571.285609 0 0 0 12.793402-207.508977 22.260519 22.260519 0 0 0-21.748783-22.260519H165.298811a21.748783 21.748783 0 0 1-16.375554-36.077393L496.39205 7.436293a21.748783 21.748783 0 0 1 32.751108 0z"
                    p-id="2693" fill="#d81e06"></path>
                </svg>
                <div v-else style="width: 25px;">&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_item ciyun">
          <div class="bottom_title">
            <div class="titlebox">
              <div class="titlepoint"></div>
              热门词云
            </div>
          </div>
          <div class="botcontent">
            <div id="container"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_right">
      <div class="righttop" v-if="aibox.name == '晓知因'">
        <div class="titlebox">
          <div class="titlepoint"></div>
          全国PV分布图
        </div>
        <div class="slmap" id="suanlimap"></div>
        <div class="titlebox">
          <div class="titlepoint"></div>
          数据报告
        </div>
        <div class="contitem">
          <p class="name">2024年第一季度GDP</p>
          <p class="num b">29.63<span>万亿元</span></p>
        </div>
        <div class="contitem">
          <p class="name">2023年国内经济增速</p>
          <!-- <p class="stitle">对比上年</p>
          <p class="num">105.2<span>%</span></p> -->
          <div class="detailchart" id="price1"></div>
        </div>
      </div>
      <div class="righttop otherbot" v-else-if="aibox.name == '绿小影'">
        <div class="titlebox">
          <div class="titlepoint"></div>
          行业情报
        </div>
        <div class="contitem">
          <div class="lxytitle">
            <img src="./img/lt0.png" alt="" /> 168城市综指倒排
          </div>
          <div class="timebox">
            <div class="datebox">
              <input type="date" :value="lxytime" @change="lxytimechange" />
            </div>
            <div class="timetypebox">
              <div @click="lxytimeclick('2')" :class="lxytimetype == '2' ? 'timeitem ted' : 'timeitem'">
                日
              </div>
              <div @click="lxytimeclick('3')" :class="lxytimetype == '3' ? 'timeitem ted' : 'timeitem'">
                月
              </div>
              <div @click="lxytimeclick('4')" :class="lxytimetype == '4' ? 'timeitem ted' : 'timeitem'">
                年
              </div>
            </div>
          </div>
          <div class="tablebox">
            <div class="theadbox">
              <div class="th">排序</div>
              <div class="th">城市</div>
              <div class="th">综指</div>
              <div class="th">消减率</div>
              <div class="th"></div>
            </div>
            <div class="tbodybox">
              <div class="tr" v-for="(item, i) in lxytabledata" :key="i">
                <div class="td">{{ i + 1 }}</div>
                <div class="td">{{ item.name }}</div>
                <div class="td">{{ item.value }}</div>
                <div class="td">
                  {{ Math.abs(Number(item.ratio_t * 100)).toFixed(2) }}%
                </div>
                <div class="td">
                  <svg v-if="item.ratio_t > 0" t="1717495519275" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="6131" width="16" height="16">
                    <path
                      d="M564.73437499 512l-105.46874998 0L459.265625 889.94726563A43.92773438 43.92773438 0 0 0 503.19335937 933.875l17.61328126 0A43.92773438 43.92773438 0 0 0 564.734375 889.94726563L564.73437499 512z"
                      fill="#FF3636" p-id="6132"></path>
                    <path
                      d="M734.328125 445.02734375l-181.93359375-295.04882813a43.92773438 43.92773438 0 0 0-74.51367188-0.47460937l-186.83789062 295.04882813A43.92773438 43.92773438 0 0 0 328.16796874 512L696.93945313 512a43.92773438 43.92773438 0 0 0 37.44140624-66.97265625z"
                      fill="#FF3636" p-id="6133"></path>
                  </svg>
                  <svg v-else t="1717505336931" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="1491" width="16" height="16">
                    <path
                      d="M459.26562501 512l105.46874998 0L564.734375 134.05273437A43.92773438 43.92773438 0 0 0 520.80664063 90.125l-17.61328126 0A43.92773438 43.92773438 0 0 0 459.265625 134.05273437L459.26562501 512z"
                      p-id="1492" fill="#1afa29"></path>
                    <path
                      d="M289.671875 578.97265625l181.93359375 295.04882813a43.92773438 43.92773438 0 0 0 74.51367188 0.47460937l186.83789062-295.04882813A43.92773438 43.92773438 0 0 0 695.83203126 512L327.06054687 512a43.92773438 43.92773438 0 0 0-37.44140624 66.97265625z"
                      p-id="1493" fill="#1afa29"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contitem">
          <div class="lxytitle">
            <img src="./img/lt4.png" alt="" /> 督查热点情报
          </div>
          <div class="wzbox">
            <div class="lxywzitem" @click="openweb(item.url)" v-for="(item, i) in wzlist.dcjz" :key="i">
              <p>{{ item.title }}</p>
              <div class="wztimebox">
                <img src="./img/time.png" /> {{ item.createTime.substr(0, 10) }}
              </div>
            </div>
          </div>
        </div>
        <div class="contitem">
          <div class="lxytitle">
            <img src="./img/lt3.png" alt="" /> 督查整改情报
          </div>
          <div class="wzbox">
            <div class="lxywzitem" @click="openweb(item.url)" v-for="(item, i) in wzlist.dczg" :key="i">
              <p>{{ item.title }}</p>
              <div class="wztimebox">
                <img src="./img/time.png" /> {{ item.createTime.substr(0, 10) }}
              </div>
            </div>
          </div>
        </div>
        <div class="contitem">
          <div class="lxytitle">
            <img src="./img/lt1.png" alt="" /> 督查问责情报
          </div>
          <div class="wzbox">
            <div class="lxywzitem" @click="openweb(item.url)" v-for="(item, i) in wzlist.dcgl" :key="i">
              <p>{{ item.title }}</p>
              <div class="wztimebox">
                <img src="./img/time.png" /> {{ item.createTime.substr(0, 10) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="righttop otherbot" v-else>
        <div class="titlebox">
          <div class="titlepoint"></div>
          数据报告
        </div>
        <div class="contitem">
          <p class="name">{{ priceitem.name + '价格' }}</p>
          <p class="num b">
            {{ priceitem.price }}<span>{{ priceitem.unit }}</span>
          </p>
        </div>
        <div class="contitem">
          <p class="name">
            {{
              zengsuvalue.name
                ? zengsuvalue.name.substr(0, zengsuvalue.name.indexOf('_')) +
                '增速'
                : ''
            }}
          </p>
          <!-- <p class="stitle">对比上年</p>
          <p class="num">105.2<span>%</span></p> -->
          <div class="detailchart" id="price3"></div>
        </div>
        <div class="contitem">
          <p class="name">
            {{
                chanliangvalue.name
                  ? chanliangvalue.name.includes('_')
                    ? chanliangvalue.name.substr(
                      0,
                      chanliangvalue.name.indexOf('_')
                    )
                    : chanliangvalue.name
                  : ''
              }}
          </p>
          <p class="num b">
            {{ chanliangvalue.value ? chanliangvalue.value['2024年3月'] : ''
            }}<span v-if="chanliangvalue.value">吨</span>
          </p>
        </div>
        <div class="contitem">
          <p class="name">{{ chanzhivalue.name }}</p>
          <p class="num b">
            {{ chanzhivalue.value ? chanzhivalue.value['2016'] : '' }}
          </p>
        </div>
      </div>

      <div class="hdbox" :style="{ marginTop: aibox.name == '晓知因' ? '70px' : '20px' }">
        <div class="titlebox">
          <div class="titlepoint"></div>
          最新资讯
        </div>
        <div class="contitem" :style="{ height: aibox.name == '晓知因' ? '210px' : '260px' }">
          <el-carousel v-if="aibox.name == '盐小氟'" :height="aibox.name == '晓知因' ? '190px' : '250px'">
            <el-carousel-item>
              <img src="./img/mybot/hd12.png" @click="openpdf('./hd1.pdf')" style="width: 100%; height: 100%" />
            </el-carousel-item>
            <el-carousel-item>
              <img src="./img/mybot/hd22.png" @click="openpdf('./hd2.pdf')" style="width: 100%; height: 100%" />
            </el-carousel-item>
            <el-carousel-item>
              <img src="./img/mybot/hd32.png" @click="openpdf('./hd3.pdf')" style="width: 100%; height: 100%" />
            </el-carousel-item>
          </el-carousel>
          <el-carousel v-else :height="aibox.name == '晓知因' ? '190px' : '250px'">
            <el-carousel-item>
              <img src="./img/mybot/hd1.png" />
            </el-carousel-item>
            <el-carousel-item>
              <img src="./img/mybot/hd2.png" />
            </el-carousel-item>
            <el-carousel-item>
              <img src="./img/mybot/hd3.png" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import chinaCityJson from './china.json'
import { getGoodsPrice } from '@/api/home'
import { getRank, getLxyWzData } from '@/api/lxy'
import { baseUrl } from '@/axios/baseUrl'
import { formatTime } from '@/utils';
// wordcloud(Highcharts);
export default {
  name: '',
  components: {},
  data(props) {
    return {
      smenu: 'web',
      value: '100',
      aibox: props.aiboxitem || [],
      aicount: [],
      hotai: [],
      aizblist: [],
      newaiData: [],
      aizbcharts: [],
      priceitem: [],
      thisaibotcount: [], //zs{ "机器人": "", "type": "合成橡胶产量_同比增长(%)", "2024年3月": -1.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": -2.9, "2023年11月": 7.9, "2023年10月": 10.9, "2023年9月": 15.7, "2023年8月": 14.2, "2023年7月": 7.7, "2023年6月": 4.4, "2023年5月": 4.5, "2023年4月": 14.7, "2023年3月": 7.1 }, { "机器人": "", "type": "合成橡胶产量_累计增长(%)", "2024年3月": 1.4, "2024年2月": 3.9, "2024年1月": 0, "2023年12月": 8.2, "2023年11月": 9.2, "2023年10月": 9.3, "2023年9月": 9.3, "2023年8月": 8.8, "2023年7月": 7.6, "2023年6月": -0.9, "2023年5月": 9.3, "2023年4月": 10.7, "2023年3月": 9.5 }, al{ "机器人": "", "type": "合成橡胶产量_当期值(万吨)", "2024年3月": 73.6, "2024年2月": 0, "2024年1月": 0, "2023年12月": 80.3, "2023年11月": 80.3, "2023年10月": 84.7, "2023年9月": 84.6, "2023年8月": 79.4, "2023年7月": 74.4, "2023年6月": 72.9, "2023年5月": 71.6, "2023年4月": 71.8, "2023年3月": 75.7 }, { "机器人": "", "type": "合成橡胶产量_累计值(万吨)", "2024年3月": 212.5, "2024年2月": 141.9, "2024年1月": 0, "2023年12月": 909.7, "2023年11月": 829.3, "2023年10月": 750.8, "2023年9月": 665.6, "2023年8月": 579.1, "2023年7月": 499.9, "2023年6月": 427.1, "2023年5月": 352.4, "2023年4月": 281.2, "2023年3月": 211.1 },
      zengsujson: { "data": [{ "机器人": "盐小氟", "type": "硫酸（折100％）产量_同比增长(%)", "2024年3月": 7.8, "2024年2月": 0, "2024年1月": 0, "2023年12月": 9.7, "2023年11月": 3.1, "2023年10月": 6.1, "2023年9月": 8.5, "2023年8月": 7.1, "2023年7月": 2.1, "2023年6月": -7.5, "2023年5月": -1.1, "2023年4月": 0.5, "2023年3月": 4.5 }, { "机器人": "", "type": "硫酸（折100％）产量_累计增长(%)", "2024年3月": 9.2, "2024年2月": 8.5, "2024年1月": 0, "2023年12月": 3.4, "2023年11月": 2.8, "2023年10月": 2.7, "2023年9月": 2.3, "2023年8月": 1.4, "2023年7月": 0.7, "2023年6月": 0.9, "2023年5月": 3.1, "2023年4月": 1.7, "2023年3月": 1.8 }, { "机器人": "", "type": "烧碱（折100％）产量_同比增长(%", "2024年3月": 3.5, "2024年2月": 0, "2024年1月": 0, "2023年12月": 7.7, "2023年11月": 6.6, "2023年10月": 5.8, "2023年9月": 2.6, "2023年8月": 5.6, "2023年7月": -0.8, "2023年6月": -3.1, "2023年5月": -0.3, "2023年4月": 4.9, "2023年3月": 9 }, { "机器人": "", "type": "烧碱（折100％）产量_累计增长(%)", "2024年3月": 2.9, "2024年2月": 3.3, "2024年1月": 0, "2023年12月": 3.5, "2023年11月": 3, "2023年10月": 2.5, "2023年9月": 2.1, "2023年8月": 2.2, "2023年7月": 2, "2023年6月": 2.5, "2023年5月": 4.2, "2023年4月": 5.7, "2023年3月": 7.7 }, { "机器人": "", "type": "纯碱（碳酸钠）产量_同比增长(%)", "2024年3月": 17.4, "2024年2月": 0, "2024年1月": 0, "2023年12月": 14.2, "2023年11月": 7.6, "2023年10月": 21.4, "2023年9月": 13.9, "2023年8月": 14, "2023年7月": 8.7, "2023年6月": 3.5, "2023年5月": 1.6, "2023年4月": 6.5, "2023年3月": 9.6 }, { "机器人": "盐小氟", "type": "纯碱（碳酸钠）产量_累计增长(%)", "2024年3月": 18.7, "2024年2月": 18.6, "2024年1月": 0, "2023年12月": 10.1, "2023年11月": 9.5, "2023年10月": 9.7, "2023年9月": 8.3, "2023年8月": 7.6, "2023年7月": 6.6, "2023年6月": 6.4, "2023年5月": 7, "2023年4月": 10.8, "2023年3月": 8.2 }, { "机器人": "", "type": "乙烯产量_同比增长(%)", "2024年3月": 3.6, "2024年2月": 0, "2024年1月": 0, "2023年12月": 0.1, "2023年11月": 4.8, "2023年10月": 5.6, "2023年9月": 5.7, "2023年8月": 16.8, "2023年7月": 5.2, "2023年6月": -0.8, "2023年5月": 7.1, "2023年4月": 17.9, "2023年3月": 3.6 }, { "机器人": "", "type": "乙烯产量_累计增长(%)", "2024年3月": 1.5, "2024年2月": -0.9, "2024年1月": 0, "2023年12月": 6, "2023年11月": 6.4, "2023年10月": 6.6, "2023年9月": 6.7, "2023年8月": 6.7, "2023年7月": 5.3, "2023年6月": 3.8, "2023年5月": 4.7, "2023年4月": 4.2, "2023年3月": -0.1 }, { "机器人": "绿小影", "type": "太阳能电池（光伏电池）产量_同比增长(%)", "2024年3月": 28.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": 35.7, "2023年11月": 44.5, "2023年10月": 62.8, "2023年9月": 65.4, "2023年8月": 77.8, "2023年7月": 65.1, "2023年6月": 62.6, "2023年5月": 53.1, "2023年4月": 69.1, "2023年3月": 69.7 }, { "机器人": "", "type": "太阳能电池（光伏电池）产量_累计增长(%)", "2024年3月": 20.1, "2024年2月": 8.6, "2024年1月": 0, "2023年12月": 54, "2023年11月": 56.2, "2023年10月": 63.7, "2023年9月": 63.2, "2023年8月": 60.2, "2023年7月": 56.3, "2023年6月": 54.5, "2023年5月": 53.6, "2023年4月": 56.7, "2023年3月": 53.2 }, { "机器人": "铜小铝", "type": "铁矿石原矿产量_同比增长(%)", "2024年3月": 14.5, "2024年2月": 0, "2024年1月": 0, "2023年12月": 0.4, "2023年11月": 6.6, "2023年10月": 29.8, "2023年9月": -0.9, "2023年8月": 1.3, "2023年7月": 8, "2023年6月": 1.8, "2023年5月": -2.9, "2023年4月": 0.7, "2023年3月": -4.8 }, { "机器人": "", "type": "铁矿石原矿产量_累计增长(%)", "2024年3月": 15.3, "2024年2月": 14.4, "2024年1月": 0, "2023年12月": 7.1, "2023年11月": 7.1, "2023年10月": 7.8, "2023年9月": 6.1, "2023年8月": 7, "2023年7月": 6.5, "2023年6月": 5.7, "2023年5月": 6.5, "2023年4月": 8, "2023年3月": 0.7 }, { "机器人": "", "type": "夹层玻璃产量_同比增长(%)", "2024年3月": 7.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": 36.1, "2023年11月": 16.2, "2023年10月": 0.6, "2023年9月": 11.9, "2023年8月": 6.5, "2023年7月": 2.1, "2023年6月": 9, "2023年5月": 14, "2023年4月": 17.9, "2023年3月": 8.5 }, { "机器人": "", "type": "夹层玻璃产量_累计增长(%)", "2024年3月": 9.8, "2024年2月": 11.1, "2024年1月": 0, "2023年12月": 9.2, "2023年11月": 5.8, "2023年10月": 6.6, "2023年9月": 5.5, "2023年8月": 4.8, "2023年7月": 4.1, "2023年6月": 5.1, "2023年5月": 4.8, "2023年4月": 1.8, "2023年3月": -2 }, { "机器人": "", "type": "中空玻璃产量_同比增长(%)", "2024年3月": -1.8, "2024年2月": 0, "2024年1月": 0, "2023年12月": 4, "2023年11月": 3, "2023年10月": 1.6, "2023年9月": -1.9, "2023年8月": 1.7, "2023年7月": 3.6, "2023年6月": 3.2, "2023年5月": 5.3, "2023年4月": 0.2, "2023年3月": -3 }, { "机器人": "", "type": "中空玻璃产量_累计增长(%", "2024年3月": 5, "2024年2月": 8.6, "2024年1月": 0, "2023年12月": 1.5, "2023年11月": 1.5, "2023年10月": 1.5, "2023年9月": 1.7, "2023年8月": 2.3, "2023年7月": 1.3, "2023年6月": 2, "2023年5月": 1.5, "2023年4月": -2.8, "2023年3月": -7.7 }, { "机器人": "", "type": "原盐产量_同比增长(%)", "2024年3月": 9.9, "2024年2月": 0, "2024年1月": 0, "2023年12月": 2.6, "2023年11月": 31.3, "2023年10月": 9.5, "2023年9月": 22.3, "2023年8月": 2.9, "2023年7月": -8.2, "2023年6月": 6.2, "2023年5月": 9.5, "2023年4月": -4, "2023年3月": -7 }, { "机器人": "", "type": "原盐产量_累计增长(%)", "2024年3月": 7.3, "2024年2月": 7.1, "2024年1月": 0, "2023年12月": 5.1, "2023年11月": 5.4, "2023年10月": 3.4, "2023年9月": 2.5, "2023年8月": 0, "2023年7月": -0.4, "2023年6月": -0.8, "2023年5月": -1.3, "2023年4月": -5, "2023年3月": -5 }, { "机器人": "", "type": "生铁产量_同比增长(%)", "2024年3月": -6.9, "2024年2月": 0, "2024年1月": 0, "2023年12月": -11.8, "2023年11月": -4.8, "2023年10月": -2.8, "2023年9月": -3.3, "2023年8月": 4.8, "2023年7月": 10.2, "2023年6月": 0, "2023年5月": -4.8, "2023年4月": 1, "2023年3月": 7.3 }, { "机器人": "", "type": "生铁产量_累计增长(%)", "2024年3月": -2.9, "2024年2月": -0.6, "2024年1月": 0, "2023年12月": 0.7, "2023年11月": 1.8, "2023年10月": 2.3, "2023年9月": 2.8, "2023年8月": 3.7, "2023年7月": 3.5, "2023年6月": 2.7, "2023年5月": 3.2, "2023年4月": 5.8, "2023年3月": 7.6 }, { "机器人": "", "type": "粗钢产量_同比增长(%)", "2024年3月": -7.8, "2024年2月": 0, "2024年1月": 0, "2023年12月": -14.9, "2023年11月": 0.4, "2023年10月": -1.8, "2023年9月": -5.6, "2023年8月": 3.2, "2023年7月": 11.5, "2023年6月": 0.4, "2023年5月": -7.3, "2023年4月": -1.5, "2023年3月": 6.9 }, { "机器人": "", "type": "钢材产量_同比增长(%)", "2024年3月": -1.9, "2024年2月": 1.6, "2024年1月": 0, "2023年12月": 0, "2023年11月": 1.5, "2023年10月": 1.4, "2023年9月": 1.7, "2023年8月": 2.6, "2023年7月": 2.5, "2023年6月": 1.3, "2023年5月": 1.6, "2023年4月": 4.1, "2023年3月": 6.1 }, { "机器人": "", "type": "钢材产量_累计增长(%)", "2024年3月": 4.4, "2024年2月": 7.9, "2024年1月": 0, "2023年12月": 5.2, "2023年11月": 5.7, "2023年10月": 5.7, "2023年9月": 6.1, "2023年8月": 6.3, "2023年7月": 5.4, "2023年6月": 4.4, "2023年5月": 3.2, "2023年4月": 5.2, "2023年3月": 5.8 }, { "机器人": "", "type": "钢筋产量_同比增长(%)", "2024年3月": 0.1, "2024年2月": 0, "2024年1月": 0, "2023年12月": 1.5, "2023年11月": 4.2, "2023年10月": 3, "2023年9月": 5.5, "2023年8月": 11.4, "2023年7月": 14.5, "2023年6月": 5.4, "2023年5月": -1.3, "2023年4月": 5, "2023年3月": 8.1 }, { "机器人": "", "type": "钢筋产量_累计增长(%)", "2024年3月": -22.5, "2024年2月": 0, "2024年1月": 0, "2023年12月": -7.2, "2023年11月": -8.8, "2023年10月": -12.1, "2023年9月": -11.4, "2023年8月": -1.7, "2023年7月": 18.8, "2023年6月": 3, "2023年5月": -8.8, "2023年4月": 2.1, "2023年3月": 12.1 }, { "机器人": "", "type": "线材（盘条）产量_同比增长(%)", "2024年3月": -12, "2024年2月": 0, "2024年1月": 0, "2023年12月": 1.5, "2023年11月": 3.1, "2023年10月": -4.6, "2023年9月": -2.7, "2023年8月": -2.9, "2023年7月": 11, "2023年6月": -1.2, "2023年5月": -13.3, "2023年4月": -0.4, "2023年3月": 9.7 }, { "机器人": "", "type": "线材（盘条）产量_累计增长(%)", "2024年3月": -4.9, "2024年2月": -1.5, "2024年1月": 0, "2023年12月": -0.2, "2023年11月": -0.4, "2023年10月": -0.9, "2023年9月": 0, "2023年8月": 1.2, "2023年7月": 2, "2023年6月": 0.8, "2023年5月": -0.2, "2023年4月": 5.8, "2023年3月": 7.9 }, { "机器人": "", "type": "焊接钢管产量_同比增长(%)", "2024年3月": -3.5, "2024年2月": 0, "2024年1月": 0, "2023年12月": 5.9, "2023年11月": 11, "2023年10月": 5.2, "2023年9月": 0.4, "2023年8月": 7, "2023年7月": 11.3, "2023年6月": 15.1, "2023年5月": 9.4, "2023年4月": 16.7, "2023年3月": 20.4 }, { "机器人": "", "type": "焊接钢管产量_累计增长(%)", "2024年3月": -5.6, "2024年2月": -2.6, "2024年1月": 0, "2023年12月": 8.8, "2023年11月": 11.6, "2023年10月": 11, "2023年9月": 11.1, "2023年8月": 12.8, "2023年7月": 13.1, "2023年6月": 11.4, "2023年5月": 12, "2023年4月": 15.4, "2023年3月": 13.1 }, { "机器人": "", "type": "铁合金产量_同比增长(%)", "2024年3月": -5.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": 0.1, "2023年11月": 5, "2023年10月": 11.2, "2023年9月": 14.4, "2023年8月": 19, "2023年7月": 4.7, "2023年6月": -4.2, "2023年5月": -7, "2023年4月": -5.5, "2023年3月": -0.7 }, { "机器人": "", "type": "铁合金产量_累计增长(%)", "2024年3月": -2.4, "2024年2月": -3.6, "2024年1月": 0, "2023年12月": 1.4, "2023年11月": 2.2, "2023年10月": 1.7, "2023年9月": 0.7, "2023年8月": -0.6, "2023年7月": -1.5, "2023年6月": -1.9, "2023年5月": -2.1, "2023年4月": -0.3, "2023年3月": 0.7 }, { "机器人": "", "type": "氧化铝产量_同比增长(%)", "2024年3月": 0.5, "2024年2月": 0, "2024年1月": 0, "2023年12月": 5.1, "2023年11月": 4.4, "2023年10月": 1.3, "2023年9月": 1.6, "2023年8月": -0.8, "2023年7月": -2.2, "2023年6月": -2.3, "2023年5月": -4.7, "2023年4月": -0.6, "2023年3月": -0.5 }, { "机器人": "", "type": "氧化铝产量_累计增长(%)", "2024年3月": 2.8, "2024年2月": 3.8, "2024年1月": 0, "2023年12月": 1.4, "2023年11月": 1.1, "2023年10月": 0.9, "2023年9月": 0.8, "2023年8月": 0.6, "2023年7月": 0.9, "2023年6月": 1.5, "2023年5月": 2.3, "2023年4月": 4, "2023年3月": 6.3 }, { "机器人": "", "type": "精炼铜（电解铜）产量_同比增长(%)", "2024年3月": 7.9, "2024年2月": 0, "2024年1月": 0, "2023年12月": 16.6, "2023年11月": 12.3, "2023年10月": 13.3, "2023年9月": 14.5, "2023年8月": 16.4, "2023年7月": 14.5, "2023年6月": 13.6, "2023年5月": 12.9, "2023年4月": 14.1, "2023年3月": 9 }, { "机器人": "", "type": "原铝（电解铝）产量_同比增长(%)", "2024年3月": 10, "2024年2月": 10.7, "2024年1月": 0, "2023年12月": 13.5, "2023年11月": 13.3, "2023年10月": 13.6, "2023年9月": 13.4, "2023年8月": 13.3, "2023年7月": 12.6, "2023年6月": 12.5, "2023年5月": 12.1, "2023年4月": 12.9, "2023年3月": 10.4 }, { "机器人": "", "type": "原铝（电解铝）产量_累计增长(%)", "2024年3月": 6.8, "2024年2月": 5.5, "2024年1月": 0, "2023年12月": 3.7, "2023年11月": 3.9, "2023年10月": 3.7, "2023年9月": 3.3, "2023年8月": 2.9, "2023年7月": 2.8, "2023年6月": 3.4, "2023年5月": 3.4, "2023年4月": 3.9, "2023年3月": 5.9 }, { "机器人": "", "type": "铝合金产量_同比增长(%)", "2024年3月": 10.4, "2024年2月": 0, "2024年1月": 0, "2023年12月": 36.4, "2023年11月": 6.3, "2023年10月": 12.2, "2023年9月": 11.3, "2023年8月": 9.9, "2023年7月": 7.1, "2023年6月": 17.8, "2023年5月": 15.1, "2023年4月": 19.8, "2023年3月": 16 }, { "机器人": "", "type": "铝合金产量_累计增长(%)", "2024年3月": 19.4, "2024年2月": 22.8, "2024年1月": 0, "2023年12月": 17.8, "2023年11月": 15.9, "2023年10月": 15.9, "2023年9月": 16, "2023年8月": 16.3, "2023年7月": 17.3, "2023年6月": 20.4, "2023年5月": 15.9, "2023年4月": 14.1, "2023年3月": 12.3 }, { "机器人": "", "type": "铜材产量_同比增长(%", "2024年3月": -6.5, "2024年2月": 0, "2024年1月": 0, "2023年12月": -0.2, "2023年11月": 4.5, "2023年10月": 5.1, "2023年9月": 2.4, "2023年8月": -0.5, "2023年7月": 3.9, "2023年6月": 6.6, "2023年5月": 10.2, "2023年4月": 12.4, "2023年3月": 15.5 }, { "机器人": "", "type": "铜材产量_累计增长(%)", "2024年3月": -1.2, "2024年2月": 2.8, "2024年1月": 0, "2023年12月": 4.9, "2023年11月": 4.6, "2023年10月": 5.4, "2023年9月": 6.1, "2023年8月": 6.1, "2023年7月": 7.3, "2023年6月": 6.8, "2023年5月": 6.7, "2023年4月": 6.9, "2023年3月": 7.8 }, { "机器人": "", "type": "铝材产量_同比增长(%)", "2024年3月": 8.4, "2024年2月": 0, "2024年1月": 0, "2023年12月": 14, "2023年11月": 7.6, "2023年10月": 8.3, "2023年9月": 5.7, "2023年8月": 6.6, "2023年7月": 2.2, "2023年6月": 13, "2023年5月": 4.1, "2023年4月": 7, "2023年3月": 9.1 }, { "机器人": "", "type": "铝材产量_累计增长(%)", "2024年3月": 13.5, "2024年2月": 11.5, "2024年1月": 0, "2023年12月": 5.7, "2023年11月": 5.2, "2023年10月": 5.7, "2023年9月": 5.2, "2023年8月": 4.3, "2023年7月": 4, "2023年6月": 10.2, "2023年5月": 4, "2023年4月": 3.7, "2023年3月": 2.9 }, { "机器人": "鲁小班", "type": "家用电冰箱（家用冷冻冷藏箱）产量_同比增长(%)", "2024年3月": 13.2, "2024年2月": 0, "2024年1月": 0, "2023年12月": 14.6, "2023年11月": 20.4, "2023年10月": 20.3, "2023年9月": 13.2, "2023年8月": 20.8, "2023年7月": 15.3, "2023年6月": 21.4, "2023年5月": 28.4, "2023年4月": 29.7, "2023年3月": 9 }, { "机器人": "", "type": "家用电冰箱（家用冷冻冷藏箱）产量_累计增长(%)", "2024年3月": 12.8, "2024年2月": 12.8, "2024年1月": 0, "2023年12月": 14.5, "2023年11月": 14.5, "2023年10月": 14.1, "2023年9月": 13.6, "2023年8月": 14.5, "2023年7月": 13.8, "2023年6月": 13.3, "2023年5月": 12.4, "2023年4月": 11, "2023年3月": 8.4 }, { "机器人": "", "type": "蚕丝及交织机织物（含蚕丝≥30％）产量_同比增长(%)", "2024年3月": 14.4, "2024年2月": 0, "2024年1月": 0, "2023年12月": 4.7, "2023年11月": 10.5, "2023年10月": 6, "2023年9月": 8.6, "2023年8月": 2.3, "2023年7月": -0.2, "2023年6月": -8.9, "2023年5月": 10.7, "2023年4月": -5.1, "2023年3月": -21.5 }, { "机器人": "", "type": "蚕丝及交织机织物（含蚕丝≥30％）产量_累计增长(%)", "2024年3月": 11.9, "2024年2月": 4.4, "2024年1月": 0, "2023年12月": 0.4, "2023年11月": 0, "2023年10月": -2.1, "2023年9月": -2.5, "2023年8月": -4.8, "2023年7月": -6.1, "2023年6月": -18.3, "2023年5月": -8.1, "2023年4月": -14.8, "2023年3月": -16.7 }, { "机器人": "", "type": "家用冷柜（家用冷冻箱）产量_同比增长(%)", "2024年3月": 19.8, "2024年2月": 0, "2024年1月": 0, "2023年12月": 38.7, "2023年11月": 43.1, "2023年10月": 29.8, "2023年9月": 14.2, "2023年8月": 20.5, "2023年7月": 40.8, "2023年6月": 26.4, "2023年5月": 11.9, "2023年4月": 24.5, "2023年3月": 6.7 }, { "机器人": "", "type": "家用冷柜（家用冷冻箱）产量_累计增长(%)", "2024年3月": 29, "2024年2月": 34.8, "2024年1月": 0, "2023年12月": 16.7, "2023年11月": 14.5, "2023年10月": 12.3, "2023年9月": 10.7, "2023年8月": 7, "2023年7月": 5.2, "2023年6月": -1.2, "2023年5月": -5.4, "2023年4月": -9.4, "2023年3月": -16.9 }, { "机器人": "", "type": "房间空气调节器产量_同比增长(%)", "2024年3月": 13.2, "2024年2月": 0, "2024年1月": 0, "2023年12月": 26.9, "2023年11月": 12.8, "2023年10月": -0.5, "2023年9月": -9.7, "2023年8月": 5.9, "2023年7月": 29, "2023年6月": 25.2, "2023年5月": 18.3, "2023年4月": 12.1, "2023年3月": 13.2 }, { "机器人": "", "type": "房间空气调节器产量_累计增长(%)", "2024年3月": 16.5, "2024年2月": 18.8, "2024年1月": 0, "2023年12月": 13.5, "2023年11月": 12.6, "2023年10月": 12.4, "2023年9月": 13.7, "2023年8月": 16.5, "2023年7月": 17.9, "2023年6月": 16.6, "2023年5月": 14.2, "2023年4月": 12.2, "2023年3月": 12.6 }, { "机器人": "", "type": "家用洗衣机产量_同比增长(%)", "2024年3月": 5.9, "2024年2月": 0, "2024年1月": 0, "2023年12月": 11.9, "2023年11月": 13.4, "2023年10月": 14.5, "2023年9月": 24.2, "2023年8月": 40.9, "2023年7月": 15.9, "2023年6月": 25.5, "2023年5月": 29.4, "2023年4月": 41.6, "2023年3月": 18.8 }, { "机器人": "", "type": "家用洗衣机产量_累计增长(%)", "2024年3月": 13.8, "2024年2月": 18.5, "2024年1月": 0, "2023年12月": 19.3, "2023年11月": 20, "2023年10月": 20.7, "2023年9月": 21.9, "2023年8月": 23.6, "2023年7月": 19.9, "2023年6月": 20.5, "2023年5月": 18.9, "2023年4月": 15, "2023年3月": 6.9 }, { "机器人": "牛么么", "type": "饲料产量_同比增长", "2024年3月": 0.8, "2024年2月": 0, "2024年1月": 0, "2023年12月": -4.6, "2023年11月": -0.6, "2023年10月": 0.4, "2023年9月": -3.5, "2023年8月": 3.9, "2023年7月": 6.2, "2023年6月": 5, "2023年5月": 3.5, "2023年4月": 6.3, "2023年3月": 0.5 }, { "机器人": "", "type": "饲料产量_累计增长(%)", "2024年3月": -0.8, "2024年2月": -2.1, "2024年1月": 0, "2023年12月": 1.4, "2023年11月": 2, "2023年10月": 2.4, "2023年9月": 2.4, "2023年8月": 2.9, "2023年7月": 3.4, "2023年6月": 2.8, "2023年5月": 2.3, "2023年4月": 1.4, "2023年3月": 0.2 }, { "机器人": "", "type": "精制食用植物油产量_同比增长(%)", "2024年3月": 7.2, "2024年2月": 0, "2024年1月": 0, "2023年12月": 0.7, "2023年11月": 1.1, "2023年10月": 3.8, "2023年9月": 2.9, "2023年8月": 10.3, "2023年7月": 7.8, "2023年6月": 10.9, "2023年5月": 7.5, "2023年4月": 4.8, "2023年3月": 3.4 }, { "机器人": "", "type": "精制食用植物油产量_累计增长(%)", "2024年3月": 3.1, "2024年2月": 0.7, "2024年1月": 0, "2023年12月": 5.9, "2023年11月": 6.3, "2023年10月": 6.3, "2023年9月": 6.3, "2023年8月": 6.4, "2023年7月": 5.7, "2023年6月": 5.9, "2023年5月": 7.4, "2023年4月": 9.1, "2023年3月": 9.9 }, { "机器人": "", "type": "成品糖产量_同比增长(%)", "2024年3月": 51.6, "2024年2月": 0, "2024年1月": 0, "2023年12月": -2, "2023年11月": 2.2, "2023年10月": 5.8, "2023年9月": -31.1, "2023年8月": -18.7, "2023年7月": -32.1, "2023年6月": -23.7, "2023年5月": -37.8, "2023年4月": -33.1, "2023年3月": -38.8 }, { "机器人": "", "type": "成品糖产量_累计增长(%)", "2024年3月": 14.2, "2024年2月": 2.9, "2024年1月": 0, "2023年12月": -13.2, "2023年11月": -13.6, "2023年10月": -14.8, "2023年9月": -16, "2023年8月": -15.2, "2023年7月": -15.1, "2023年6月": -14.7, "2023年5月": -14.6, "2023年4月": -13.7, "2023年3月": -10.3 }, { "机器人": "", "type": "鲜、冷藏肉产量_同比增长(%)", "2024年3月": 6.8, "2024年2月": 0, "2024年1月": 0, "2023年12月": 15.2, "2023年11月": 21, "2023年10月": 23.6, "2023年9月": 16.9, "2023年8月": 14.5, "2023年7月": 21.6, "2023年6月": 15.8, "2023年5月": 17.2, "2023年4月": 6.6, "2023年3月": 0.1 }, { "机器人": "", "type": "鲜、冷藏肉产量_累计增长(%)", "2024年3月": 7.8, "2024年2月": 8.9, "2024年1月": 0, "2023年12月": 15.3, "2023年11月": 14.4, "2023年10月": 12.8, "2023年9月": 11.5, "2023年8月": 11.1, "2023年7月": 10.8, "2023年6月": 10.5, "2023年5月": 8.9, "2023年4月": 3.7, "2023年3月": 0.3 }, { "机器人": "", "type": "乳制品产量_同比增长(%)", "2024年3月": -4.8, "2024年2月": 0, "2024年1月": 0, "2023年12月": 1.6, "2023年11月": -1.9, "2023年10月": 0.9, "2023年9月": 2.1, "2023年8月": 3.4, "2023年7月": 3.1, "2023年6月": -0.1, "2023年5月": 3.5, "2023年4月": 8.1, "2023年3月": 7.4 }, { "机器人": "", "type": "乳制品产量_累计增长(%)", "2024年3月": 1, "2024年2月": 1.3, "2024年1月": 0, "2023年12月": 3.1, "2023年11月": 3.3, "2023年10月": 3.7, "2023年9月": 3.8, "2023年8月": 3.6, "2023年7月": 4.5, "2023年6月": 4.6, "2023年5月": 7, "2023年4月": 5.3, "2023年3月": 4.6 }, { "机器人": "", "type": "白酒（折65度，商品量）产量_同比增长(%)", "2024年3月": 6.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": 4, "2023年11月": 7.1, "2023年10月": 2.5, "2023年9月": 12.6, "2023年8月": -5.3, "2023年7月": -3.7, "2023年6月": -4.5, "2023年5月": -14.7, "2023年4月": -28.1, "2023年3月": -29.2 }, { "机器人": "", "type": "白酒（折65度，商品量）产量_累计增长(%)", "2024年3月": 2.6, "2024年2月": 0, "2024年1月": -2.8, "2023年12月": -6, "2023年11月": -7.7, "2023年10月": -9, "2023年9月": -13.2, "2023年8月": -13.3, "2023年7月": -14.8, "2023年6月": -13.6, "2023年5月": -29.6, "2023年4月": -19, "2023年3月": "" }, { "机器人": "", "type": "啤酒产量_同比增长(%)", "2024年3月": -6.5, "2024年2月": 0, "2024年1月": 0, "2023年12月": -15.3, "2023年11月": -8.9, "2023年10月": 0.4, "2023年9月": -8, "2023年8月": -5.8, "2023年7月": -3.4, "2023年6月": 1.6, "2023年5月": 7, "2023年4月": 21.1, "2023年3月": 20.4 }, { "机器人": "", "type": "啤酒产量_累计增长(%)", "2024年3月": 6.1, "2024年2月": 12.1, "2024年1月": 0, "2023年12月": 0.3, "2023年11月": 1.6, "2023年10月": 2.2, "2023年9月": 2.1, "2023年8月": 3.1, "2023年7月": 4.9, "2023年6月": 7, "2023年5月": 8.4, "2023年4月": 8.8, "2023年3月": 4.5 }, { "机器人": "", "type": "葡萄酒产量_同比增长(%", "2024年3月": -7.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": -12, "2023年11月": 0, "2023年10月": -8.3, "2023年9月": 7.1, "2023年8月": -16.7, "2023年7月": -9.1, "2023年6月": 0, "2023年5月": 0, "2023年4月": -18.2, "2023年3月": -5.9 }, { "机器人": "", "type": "葡萄酒产量_累计增长(%)", "2024年3月": 3.2, "2024年2月": 17.6, "2024年1月": 0, "2023年12月": 2.9, "2023年11月": 3.4, "2023年10月": -14, "2023年9月": -14.5, "2023年8月": -16.7, "2023年7月": -17.8, "2023年6月": -16.5, "2023年5月": -22.7, "2023年4月": -26.8, "2023年3月": -26.5 }, { "机器人": "", "type": "饮料产量_同比增长(%)", "2024年3月": 3.3, "2024年2月": 0, "2024年1月": 0, "2023年12月": 4, "2023年11月": 4.3, "2023年10月": -3.8, "2023年9月": -0.5, "2023年8月": -0.1, "2023年7月": -0.3, "2023年6月": 4.8, "2023年5月": 8.9, "2023年4月": 9.5, "2023年3月": 5 }, { "机器人": "", "type": "饮料产量_累计增长(%)", "2024年3月": 7, "2024年2月": 8, "2024年1月": 0, "2023年12月": 4.1, "2023年11月": 4, "2023年10月": 3.6, "2023年9月": 3.5, "2023年8月": 4, "2023年7月": 6.1, "2023年6月": 6, "2023年5月": 6, "2023年4月": 5, "2023年3月": 1 }, { "机器人": "红小鬼", "type": "智能手表产量_同比增长(%)", "2024年3月": 6.1, "2024年2月": 0, "2024年1月": 0, "2023年12月": -5.4, "2023年11月": -11.9, "2023年10月": -5.4, "2023年9月": -9.7, "2023年8月": -27.1, "2023年7月": 7.7, "2023年6月": 6.8, "2023年5月": -24.1, "2023年4月": -25.5, "2023年3月": 16 }, { "机器人": "", "type": "智能手表产量_累计增长(%)", "2024年3月": 24.7, "2024年2月": 41.6, "2024年1月": 0, "2023年12月": -5.9, "2023年11月": -5.9, "2023年10月": -4.6, "2023年9月": -4.4, "2023年8月": -3.3, "2023年7月": 1.7, "2023年6月": -1.7, "2023年5月": -8.6, "2023年4月": -15.3, "2023年3月": -14 }, { "机器人": "垚小稀", "type": "十种有色金属产量_同比增长(%)", "2024年3月": 7.1, "2024年2月": 0, "2024年1月": 0, "2023年12月": 7.3, "2023年11月": 7.1, "2023年10月": 8.2, "2023年9月": 7.3, "2023年8月": 6.1, "2023年7月": 4.2, "2023年6月": 6.1, "2023年5月": 5.1, "2023年4月": 6.1, "2023年3月": 6.9 }, { "机器人": "", "type": "十种有色金属产量_累计增长(%)", "2024年3月": 7, "2024年2月": 5.7, "2024年1月": 0, "2023年12月": 7.1, "2023年11月": 7.2, "2023年10月": 7, "2023年9月": 6.8, "2023年8月": 6.8, "2023年7月": 7, "2023年6月": 8, "2023年5月": 7.4, "2023年4月": 7.7, "2023年3月": 9 }, { "机器人": "", "type": "铅产量_同比增长(%)", "2024年3月": -4, "2024年2月": 0, "2024年1月": 0, "2023年12月": -4.7, "2023年11月": -3, "2023年10月": 8, "2023年9月": 13, "2023年8月": 5.5, "2023年7月": 7.7, "2023年6月": 6.8, "2023年5月": -0.6, "2023年4月": 3.9, "2023年3月": 8.8 }, { "机器人": "", "type": "铅产量_累计增长(%)", "2024年3月": -9.9, "2024年2月": -14.5, "2024年1月": 0, "2023年12月": 11.2, "2023年11月": 12.2, "2023年10月": 12.9, "2023年9月": 13.5, "2023年8月": 13.7, "2023年7月": 14.9, "2023年6月": 16.7, "2023年5月": 10, "2023年4月": 8.7, "2023年3月": 16.2 }, { "机器人": "", "type": "锌产量_同比增长(%", "2024年3月": 3.5, "2024年2月": 0, "2024年1月": 0, "2023年12月": 9.6, "2023年11月": 10.4, "2023年10月": 7.7, "2023年9月": -0.5, "2023年8月": 5.2, "2023年7月": 4.3, "2023年6月": 8.4, "2023年5月": 10.3, "2023年4月": 12.9, "2023年3月": 9.5 }, { "机器人": "", "type": "锌产量_累计增长(%)", "2024年3月": 10.2, "2024年2月": 15.5, "2024年1月": 0, "2023年12月": 7.1, "2023年11月": 7.3, "2023年10月": 5.5, "2023年9月": 5.2, "2023年8月": 7.1, "2023年7月": 8.5, "2023年6月": 9.3, "2023年5月": 9, "2023年4月": 8.2, "2023年3月": 5.4 }] },
      chanliangjson: { "data": [{ "机器人": "盐小氟", "type": "硫酸（折100％）产量_当期值(万吨)", "2024年3月": 890, "2024年2月": 0, "2024年1月": 0, "2023年12月": 906.58681, "2023年11月": 817.4, "2023年10月": 822.1, "2023年9月": 807.7, "2023年8月": 791.7, "2023年7月": 764.5, "2023年6月": 733.2, "2023年5月": 751.4, "2023年4月": 779.4, "2023年3月": 859.12622 }, { "机器人": "", "type": "硫酸（折100％）产量_累计值(万吨)", "2024年3月": 2584.8, "2024年2月": 1688.92722, "2024年1月": 0, "2023年12月": 9580.04366, "2023年11月": 8680.2, "2023年10月": 7860.2, "2023年9月": 7038.9, "2023年8月": 6217.8, "2023年7月": 5442.6, "2023年6月": 4684.2, "2023年5月": 3927.5, "2023年4月": 3173.3, "2023年3月": 2429.15136 }, { "机器人": "", "type": "纯碱（碳酸钠）产量_当期值(万吨)", "2024年3月": 1058.6, "2024年2月": 686.68433, "2024年1月": 0, "2023年12月": 4101.37569, "2023年11月": 3727, "2023年10月": 3377.9, "2023年9月": 3024.9, "2023年8月": 2683.6, "2023年7月": 2345.4, "2023年6月": 2016.6, "2023年5月": 1693.4, "2023年4月": 1355.3, "2023年3月": 1025.41821 }, { "机器人": "", "type": "纯碱（碳酸钠）产量_累计值(万吨)", "2024年3月": 322.9, "2024年2月": 0, "2024年1月": 0, "2023年12月": 300.44328, "2023年11月": 291.8, "2023年10月": 309.5, "2023年9月": 272.3, "2023年8月": 249.3, "2023年7月": 251.3, "2023年6月": 266.8, "2023年5月": 263.1, "2023年4月": 263.7, "2023年3月": 267.19254 }, { "机器人": "", "type": "乙烯产量_当期值(万吨)", "2024年3月": 277.3, "2024年2月": 0, "2024年1月": 0, "2023年12月": 271.493, "2023年11月": 269.4, "2023年10月": 282.2, "2023年9月": 263.9, "2023年8月": 264.3, "2023年7月": 240.8, "2023年6月": 238.4, "2023年5月": 261.7, "2023年4月": 274.4, "2023年3月": 261.19111 }, { "机器人": "", "type": "乙烯产量_累计值(万吨)", "2024年3月": 799.1, "2024年2月": 515.39385, "2024年1月": 0, "2023年12月": 3189.88437, "2023年11月": 2915.1, "2023年10月": 2645.8, "2023年9月": 2363.6, "2023年8月": 2047.6, "2023年7月": 1783.3, "2023年6月": 1542.6, "2023年5月": 1304.9, "2023年4月": 1043.4, "2023年3月": 768.47678 }, { "机器人": "绿小影", "type": "太阳能电池（光伏电池）产量_当期值(万千瓦)", "2024年3月": 5511.4, "2024年2月": 0, "2024年1月": 0, "2023年12月": 5083.1, "2023年11月": 5310.3, "2023年10月": 5224.1, "2023年9月": 5139.6, "2023年8月": 4881, "2023年7月": 4449.5, "2023年6月": 4698.3, "2023年5月": 4150, "2023年4月": 3992, "2023年3月": 4319.6 }, { "机器人": "", "type": "太阳能电池（光伏电池）产量_累计值(万千瓦)", "2024年3月": 12588.1, "2024年2月": 6992.6, "2024年1月": 0, "2023年12月": 54115.8, "2023年11月": 49035.2, "2023年10月": 43643, "2023年9月": 38428.3, "2023年8月": 33325.2, "2023年7月": 27660.7, "2023年6月": 23241.1, "2023年5月": 18516.2, "2023年4月": 14435.1, "2023年3月": 10526.3 }, { "机器人": "铜小铝", "type": "铁矿石原矿产量_当期值(万吨)", "2024年3月": 9814.6, "2024年2月": 0, "2024年1月": 0, "2023年12月": 8603.32134, "2023年11月": 8556.8, "2023年10月": 8644.5, "2023年9月": 8436.8, "2023年8月": 8633.3, "2023年7月": 8570.9, "2023年6月": 8515.5, "2023年5月": 7760, "2023年4月": 7509.6, "2023年3月": 8640.3369 }, { "机器人": "", "type": "铁矿石原矿产量_累计值(万吨)", "2024年3月": 28409.4, "2024年2月": 17585.95549, "2024年1月": 0, "2023年12月": 99055.54092, "2023年11月": 90402.7, "2023年10月": 82575.8, "2023年9月": 74276.6, "2023年8月": 65916.9, "2023年7月": 56679.7, "2023年6月": 47675.9, "2023年5月": 39135.2, "2023年4月": 31438.2, "2023年3月": 24326.71345 }, { "机器人": "", "type": "夹层玻璃产量_当期值(万吨)", "2024年3月": 1297, "2024年2月": 0, "2024年1月": 0, "2023年12月": 1454.6, "2023年11月": 1370.7, "2023年10月": 1185.5, "2023年9月": 1323.8, "2023年8月": 1251.6, "2023年7月": 1197.6, "2023年6月": 1322.4, "2023年5月": 1175.9, "2023年4月": 1140, "2023年3月": 1286.5 }, { "机器人": "", "type": "夹层玻璃产量_累计值(万吨)", "2024年3月": 3521.4, "2024年2月": 2221.1, "2024年1月": 0, "2023年12月": 14710, "2023年11月": 13021.3, "2023年10月": 11875.8, "2023年9月": 10641.6, "2023年8月": 9315.1, "2023年7月": 8045.1, "2023年6月": 6853.1, "2023年5月": 5529.2, "2023年4月": 4364.5, "2023年3月": 3462.6 }, { "机器人": "", "type": "中空玻璃产量_当期值(万吨)", "2024年3月": 1053.2, "2024年2月": 0, "2024年1月": 0, "2023年12月": 1357.2, "2023年11月": 1366.8, "2023年10月": 1257.9, "2023年9月": 1247.3, "2023年8月": 1177.8, "2023年7月": 1208.8, "2023年6月": 1239.5, "2023年5月": 1131.2, "2023年4月": 1097.2, "2023年3月": 1196.7 }, { "机器人": "", "type": "中空玻璃产量_累计值(万吨)", "2024年3月": 2856.6, "2024年2月": 1787.7, "2024年1月": 0, "2023年12月": 13495.8, "2023年11月": 12147.6, "2023年10月": 10807.1, "2023年9月": 9699.5, "2023年8月": 8469.8, "2023年7月": 7257.4, "2023年6月": 6263.6, "2023年5月": 5052.2, "2023年4月": 4048.1, "2023年3月": 3115.3 }, { "机器人": "", "type": "原盐产量_当期值(万吨)", "2024年3月": 403.1, "2024年2月": 0, "2024年1月": 0, "2023年12月": 401.69674, "2023年11月": 466.5, "2023年10月": 618.8, "2023年9月": 485.2, "2023年8月": 392.9, "2023年7月": 385.6, "2023年6月": 658.2, "2023年5月": 580.2, "2023年4月": 387.8, "2023年3月": 337.75414 }, { "机器人": "", "type": "原盐产量_累计值(万吨)", "2024年3月": 1073.3, "2024年2月": 670.91193, "2024年1月": 0, "2023年12月": 5256.80223, "2023年11月": 4856, "2023年10月": 4395.9, "2023年9月": 3777.1, "2023年8月": 3291.8, "2023年7月": 2897.1, "2023年6月": 2514.2, "2023年5月": 1861.8, "2023年4月": 1283.2, "2023年3月": 899.01899 }, { "机器人": "", "type": "生铁产量_当期值(万吨)", "2024年3月": 7265.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": 6087.08819, "2023年11月": 6483.9, "2023年10月": 6918.7, "2023年9月": 7154.2, "2023年8月": 7462.3, "2023年7月": 7759.6, "2023年6月": 7698.1, "2023年5月": 7700.1, "2023年4月": 7784, "2023年3月": 7806.84493 }, { "机器人": "", "type": "生铁产量_累计值(万吨)", "2024年3月": 21338.9, "2024年2月": 14073.41229, "2024年1月": 0, "2023年12月": 87101.30229, "2023年11月": 81030.7, "2023年10月": 74474.8, "2023年9月": 67515.8, "2023年8月": 60358.7, "2023年7月": 52891.9, "2023年6月": 45156.4, "2023年5月": 37474.4, "2023年4月": 29762.9, "2023年3月": 21983.24003 }, { "机器人": "", "type": "粗钢产量_当期值(万吨)", "2024年3月": 8826.9, "2024年2月": 0, "2024年1月": 0, "2023年12月": 6744.38316, "2023年11月": 7609.9, "2023年10月": 7909.2, "2023年9月": 8210.8, "2023年8月": 8641.3, "2023年7月": 9079.7, "2023年6月": 9111, "2023年5月": 9012.3, "2023年4月": 9263.5, "2023年3月": 9572.5554 }, { "机器人": "", "type": "钢材产量_累计值(万吨)", "2024年3月": 25655.1, "2024年2月": 16796.17351, "2024年1月": 0, "2023年12月": 101908.12722, "2023年11月": 95214, "2023年10月": 87469.5, "2023年9月": 79507.3, "2023年8月": 71292.7, "2023年7月": 62651.4, "2023年6月": 53564.1, "2023年5月": 44462.9, "2023年4月": 35438.6, "2023年3月": 26155.57571 }, { "机器人": "", "type": "钢材产量_当期值(万吨)", "2024年3月": 12336.6, "2024年2月": 0, "2024年1月": 0, "2023年12月": 10849.47255, "2023年11月": 11043.5, "2023年10月": 11370.6, "2023年9月": 11781.5, "2023年8月": 11652.4, "2023年7月": 11653.4, "2023年6月": 12007.9, "2023年5月": 11846.9, "2023年4月": 11995.2, "2023年3月": 12724.67985 }, { "机器人": "", "type": "钢筋产量_累计值(万吨)", "2024年3月": 33602.6, "2024年2月": 21342.784, "2024年1月": 0, "2023年12月": 136268.17299, "2023年11月": 125282, "2023年10月": 114417.6, "2023年9月": 102887.3, "2023年8月": 90920.2, "2023年7月": 78899.5, "2023年6月": 67654.8, "2023年5月": 55706.1, "2023年4月": 44636.2, "2023年3月": 33259.44934 }, { "机器人": "", "type": "钢筋产量_当期值(万吨)", "2024年3月": 1778.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": 1764.4, "2023年11月": 1801, "2023年10月": 1825.1, "2023年9月": 1862.4, "2023年8月": 1877.9, "2023年7月": 2015.1, "2023年6月": 2061.8, "2023年5月": 1992.9, "2023年4月": 2110.1, "2023年3月": 2328.4 }, { "机器人": "", "type": "钢筋产量_累计值(万吨)", "2024年3月": 5001.5, "2024年2月": 3209.9, "2024年1月": 0, "2023年12月": 22638.1, "2023年11月": 20973.8, "2023年10月": 19266.9, "2023年9月": 17462.4, "2023年8月": 15602.8, "2023年7月": 13724.2, "2023年6月": 11755.8, "2023年5月": 9693.7, "2023年4月": 7733.9, "2023年3月": 5716 }, { "机器人": "", "type": "线材（盘条）产量_累计值(万吨)", "2024年3月": 3244.1, "2024年2月": 2114.3, "2024年1月": 0, "2023年12月": 13735.1, "2023年11月": 12650.9, "2023年10月": 11547.8, "2023年9月": 10678.3, "2023年8月": 9489.6, "2023年7月": 8298.9, "2023年6月": 7077.4, "2023年5月": 5837.9, "2023年4月": 4779.3, "2023年3月": 3520.7 }, { "机器人": "", "type": "线材（盘条）产量_累计值(万吨)", "2024年3月": -12, "2024年2月": 0, "2024年1月": 0, "2023年12月": 1.5, "2023年11月": 3.1, "2023年10月": -4.6, "2023年9月": -2.7, "2023年8月": -2.9, "2023年7月": 11, "2023年6月": -1.2, "2023年5月": -13.3, "2023年4月": -0.4, "2023年3月": 9.7 }, { "机器人": "", "type": "焊接钢管产量_当期值(万吨)", "2024年3月": 567.3, "2024年2月": 0, "2024年1月": 0, "2023年12月": 537.4, "2023年11月": 565.7, "2023年10月": 552.9, "2023年9月": 576.9, "2023年8月": 548.3, "2023年7月": 521.1, "2023年6月": 602.9, "2023年5月": 575.8, "2023年4月": 544.9, "2023年3月": 645.6 }, { "机器人": "", "type": "焊接钢管产量_累计值(万吨)", "2024年3月": 1192.5, "2024年2月": 652.6, "2024年1月": 0, "2023年12月": 6415.1, "2023年11月": 5886.6, "2023年10月": 5396, "2023年9月": 4819.4, "2023年8月": 4224.4, "2023年7月": 3507.9, "2023年6月": 3132, "2023年5月": 2418.1, "2023年4月": 1886.7, "2023年3月": 1414.2 }, { "机器人": "", "type": "铁合金产量_当期值(万吨)", "2024年3月": 295.4, "2024年2月": 0, "2024年1月": 0, "2023年12月": 295.8, "2023年11月": 305.1, "2023年10月": 313.5, "2023年9月": 300.8, "2023年8月": 296.5, "2023年7月": 285.3, "2023年6月": 286.3, "2023年5月": 286.5, "2023年4月": 284.4, "2023年3月": 318.6 }, { "机器人": "", "type": "铁合金产量_累计值(万吨)", "2024年3月": 860.4, "2024年2月": 567, "2024年1月": 0, "2023年12月": 3465, "2023年11月": 3179, "2023年10月": 2879.5, "2023年9月": 2572.2, "2023年8月": 2267.1, "2023年7月": 2008.9, "2023年6月": 1727.3, "2023年5月": 1440.4, "2023年4月": 1168.1, "2023年3月": 899.5 }, { "机器人": "", "type": "氧化铝产量_当期值(万吨)", "2024年3月": 677.6, "2024年2月": 0, "2024年1月": 0, "2023年12月": 684.41603, "2023年11月": 698.7, "2023年10月": 705.3, "2023年9月": 707.2, "2023年8月": 708, "2023年7月": 693.3, "2023年6月": 709, "2023年5月": 700.9, "2023年4月": 690.5, "2023年3月": 681.24591 }, { "机器人": "", "type": "氧化铝产量_累计值(万吨)", "2024年3月": 2016.6, "2024年2月": 1339.61617, "2024年1月": 0, "2023年12月": 8244.12115, "2023年11月": 7559.7, "2023年10月": 6870.1, "2023年9月": 6170.6, "2023年8月": 5453.7, "2023年7月": 4747, "2023年6月": 4059.8, "2023年5月": 3350.5, "2023年4月": 2651.6, "2023年3月": 1978.41433 }, { "机器人": "", "type": "精炼铜（电解铜）产量_当期值(万吨)", "2024年3月": 114.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": 116.9, "2023年11月": 114, "2023年10月": 113.1, "2023年9月": 113.6, "2023年8月": 111.7, "2023年7月": 103.4, "2023年6月": 109.7, "2023年5月": 109.5, "2023年4月": 105.9, "2023年3月": 105.4 }, { "机器人": "", "type": "精炼铜（电解铜）产量_累计值(万吨)", "2024年3月": 336.2, "2024年2月": 221.5, "2024年1月": 0, "2023年12月": 1298.8, "2023年11月": 1181.1, "2023年10月": 1069.2, "2023年9月": 954.9, "2023年8月": 840.8, "2023年7月": 732.3, "2023年6月": 630, "2023年5月": 520.4, "2023年4月": 411.1, "2023年3月": 299 }, { "机器人": "", "type": "原铝（电解铝）产量当期值(万吨)", "2024年3月": 358.5, "2024年2月": 0, "2024年1月": 0, "2023年12月": 358.7, "2023年11月": 354.4, "2023年10月": 361.6, "2023年9月": 357.7, "2023年8月": 360.2, "2023年7月": 348.1, "2023年6月": 345.5, "2023年5月": 341.5, "2023年4月": 333.4, "2023年3月": 336.7 }, { "机器人": "", "type": "原铝（电解铝）产量_累计值(万吨)", "2024年3月": 1069.4, "2024年2月": 709.6, "2024年1月": 0, "2023年12月": 4159.4, "2023年11月": 3800.1, "2023年10月": 3445.7, "2023年9月": 3080.8, "2023年8月": 2722.6, "2023年7月": 2361.8, "2023年6月": 2016, "2023年5月": 1670.5, "2023年4月": 1331.5, "2023年3月": 1010.2 }, { "机器人": "", "type": "铝合金产量_当期值(万吨)", "2024年3月": 144.9, "2024年2月": 0, "2024年1月": 0, "2023年12月": 139, "2023年11月": 133.5, "2023年10月": 126, "2023年9月": 126.1, "2023年8月": 124.9, "2023年7月": 121.8, "2023年6月": 126.6, "2023年5月": 120.7, "2023年4月": 117.6, "2023年3月": 132.3 }, { "机器人": "", "type": "铝合金产量_累计值(万吨)", "2024年3月": 368.6, "2024年2月": 222.1, "2024年1月": 0, "2023年12月": 1458.7, "2023年11月": 1322.1, "2023年10月": 1183.5, "2023年9月": 1047.2, "2023年8月": 928.7, "2023年7月": 806.6, "2023年6月": 685.8, "2023年5月": 535.9, "2023年4月": 416.3, "2023年3月": 312.9 }, { "机器人": "", "type": "铜材产量_当期值(万吨)", "2024年3月": 200, "2024年2月": 0, "2024年1月": 0, "2023年12月": 195.03452, "2023年11月": 201.2, "2023年10月": 196.9, "2023年9月": 201.4, "2023年8月": 186.6, "2023年7月": 187.6, "2023年6月": 211, "2023年5月": 199.9, "2023年4月": 189.6, "2023年3月": 220.0363 }, { "机器人": "", "type": "铜材产量_累计值(万吨)", "2024年3月": 486.3, "2024年2月": 287.09022, "2024年1月": 0, "2023年12月": 2216.96738, "2023年11月": 2021.1, "2023年10月": 1851.9, "2023年9月": 1652.7, "2023年8月": 1447.5, "2023年7月": 1267.6, "2023年6月": 1081.4, "2023年5月": 875.7, "2023年4月": 687, "2023年3月": 520.48773 }, { "机器人": "", "type": "铝材产量_当期值(万吨)", "2024年3月": 603, "2024年2月": 0, "2024年1月": 0, "2023年12月": 594.61502, "2023年11月": 573.7, "2023年10月": 550.1, "2023年9月": 555, "2023年8月": 548.3, "2023年7月": 528.4, "2023年6月": 603.1, "2023年5月": 542.7, "2023年4月": 541, "2023年3月": 578.90363 }, { "机器人": "", "type": "铝材产量_累计值(万吨)", "2024年3月": 1568.5, "2024年2月": 976.49304, "2024年1月": 0, "2023年12月": 6303.37868, "2023年11月": 5732.1, "2023年10月": 5204.8, "2023年9月": 4654, "2023年8月": 4089.2, "2023年7月": 3549, "2023年6月": 3187.5, "2023年5月": 2462.7, "2023年4月": 1939.9, "2023年3月": 1432.30137 }, { "机器人": "鲁小班", "type": "家用电冰箱（家用冷冻冷藏箱）产量_当期值(万台)", "2024年3月": 993.4, "2024年2月": 0, "2024年1月": 0, "2023年12月": 817.2638, "2023年11月": 828.6, "2023年10月": 827.2, "2023年9月": 885.1, "2023年8月": 838.3, "2023年7月": 849.5, "2023年6月": 875, "2023年5月": 850, "2023年4月": 840.9, "2023年3月": 936.3071 }, { "机器人": "", "type": "家用电冰箱（家用冷冻冷藏箱）产量_累计值(万台)", "2024年3月": 2362.1, "2024年2月": 1374.4125, "2024年1月": 0, "2023年12月": 9632.3084, "2023年11月": 8815.4, "2023年10月": 7996.8, "2023年9月": 7182.4, "2023年8月": 6297.3, "2023年7月": 5588.2, "2023年6月": 4738.7, "2023年5月": 3857.9, "2023年4月": 3009.4, "2023年3月": 2226.6403 }, { "机器人": "", "type": "蚕丝及交织机织物（含蚕丝≥30％）产量_当期值(万米)", "2024年3月": 2201.6, "2024年2月": 0, "2024年1月": 0, "2023年12月": 2239.1, "2023年11月": 2474.8, "2023年10月": 2279.9, "2023年9月": 2392.2, "2023年8月": 2267.1, "2023年7月": 2351.7, "2023年6月": 2290.4, "2023年5月": 2296.5, "2023年4月": 2007.3, "2023年3月": 1991.6 }, { "机器人": "", "type": "蚕丝及交织机织物（含蚕丝≥30％）产量_累计值(万米)", "2024年3月": 5688.4, "2024年2月": 3457.4, "2024年1月": 0, "2023年12月": 25641.7, "2023年11月": 23402.1, "2023年10月": 20930.5, "2023年9月": 18734.1, "2023年8月": 16233.3, "2023年7月": 13966.5, "2023年6月": 11327, "2023年5月": 9286, "2023年4月": 6946.9, "2023年3月": 5312.6 }, { "机器人": "", "type": "家用冷柜（家用冷冻箱）产量_当期值(万台)", "2024年3月": 301.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": 268.9696, "2023年11月": 242.4, "2023年10月": 205.2, "2023年9月": 218.3, "2023年8月": 220.9, "2023年7月": 215.5, "2023年6月": 219.7, "2023年5月": 207.4, "2023年4月": 205, "2023年3月": 251.7412 }, { "机器人": "", "type": "家用冷柜（家用冷冻箱）产量_累计值(万台)", "2024年3月": 735.5, "2024年2月": 427.5401, "2024年1月": 0, "2023年12月": 2596.5263, "2023年11月": 2327.5, "2023年10月": 2084.8, "2023年9月": 1880.1, "2023年8月": 1661.8, "2023年7月": 1440.9, "2023年6月": 1202.1, "2023年5月": 983.6, "2023年4月": 779.2, "2023年3月": 570.9978 }, { "机器人": "", "type": "房间空气调节器产量_当期值(万台)", "2024年3月": 3083.3, "2024年2月": 0, "2024年1月": 0, "2023年12月": 2152.9337, "2023年11月": 1595.7, "2023年10月": 1373, "2023年9月": 1611.4, "2023年8月": 1643.4, "2023年7月": 2305.8, "2023年6月": 2637.6, "2023年5月": 2606.3, "2023年4月": 2586.9, "2023年3月": 2930.6834 }, { "机器人": "", "type": "房间空气调节器产量_累计值(万台)", "2024年3月": 6878, "2024年2月": 3763.5996, "2024年1月": 0, "2023年12月": 24487.0209, "2023年11月": 22334.1, "2023年10月": 20738.5, "2023年9月": 19366.2, "2023年8月": 17745, "2023年7月": 16348, "2023年6月": 14059.9, "2023年5月": 11425, "2023年4月": 8869.5, "2023年3月": 6260.1268 }, { "机器人": "", "type": "家用洗衣机产量_当期值(万台)", "2024年3月": 932.4, "2024年2月": 0, "2024年1月": 0, "2023年12月": 923.4243, "2023年11月": 1025.3, "2023年10月": 1005.7, "2023年9月": 1035, "2023年8月": 917.1, "2023年7月": 727.4, "2023年6月": 830.5, "2023年5月": 870.5, "2023年4月": 920.9, "2023年3月": 907.0032 }, { "机器人": "", "type": "家用洗衣机产量_累计值(万台)", "2024年3月": 2559.9, "2024年2月": 1622.5149, "2024年1月": 0, "2023年12月": 10458.317, "2023年11月": 9535.8, "2023年10月": 8500.5, "2023年9月": 7495.7, "2023年8月": 6460.7, "2023年7月": 5641.4, "2023年6月": 4913, "2023年5月": 4082.5, "2023年4月": 3211.4, "2023年3月": 2295.323 }, { "机器人": "牛么么", "type": "饲料产量_当期值(万吨)", "2024年3月": 2634.4, "2024年2月": 0, "2024年1月": 0, "2023年12月": 2701.7, "2023年11月": 2784.9, "2023年10月": 2801.7, "2023年9月": 2836.2, "2023年8月": 2750.9, "2023年7月": 2662.1, "2023年6月": 2714.9, "2023年5月": 2579, "2023年4月": 2519.8, "2023年3月": 2680.9 }, { "机器人": "", "type": "饲料产量_累计值(万吨)", "2024年3月": 7153.4, "2024年2月": 4502.3, "2024年1月": 0, "2023年12月": 31358.9, "2023年11月": 28693.3, "2023年10月": 25921.7, "2023年9月": 23058.5, "2023年8月": 20176, "2023年7月": 17474.1, "2023年6月": 14821.2, "2023年5月": 12156.5, "2023年4月": 9646.4, "2023年3月": 7424 }, { "机器人": "", "type": "精制食用植物油产量_当期值(万吨)", "2024年3月": 435.4, "2024年2月": 0, "2024年1月": 0, "2023年12月": 497.3, "2023年11月": 439.7, "2023年10月": 409.4, "2023年9月": 445.7, "2023年8月": 446.6, "2023年7月": 396.2, "2023年6月": 420.1, "2023年5月": 412.4, "2023年4月": 367.5, "2023年3月": 429.8 }, { "机器人": "", "type": "精制食用植物油产量_累计值(万吨)", "2024年3月": 1190, "2024年2月": 786.7, "2024年1月": 0, "2023年12月": 4897, "2023年11月": 4411.8, "2023年10月": 3983.8, "2023年9月": 3573.9, "2023年8月": 3111.7, "2023年7月": 2665.4, "2023年6月": 2286.8, "2023年5月": 1886.2, "2023年4月": 1565.5, "2023年3月": 1229.3 }, { "机器人": "", "type": "成品糖产量_当期值(万吨)", "2024年3月": 231.6, "2024年2月": 0, "2024年1月": 0, "2023年12月": 270.81422, "2023年11月": 95.6, "2023年10月": 63.9, "2023年9月": 26.2, "2023年8月": 20.9, "2023年7月": 20.5, "2023年6月": 32.5, "2023年5月": 31.8, "2023年4月": 46.8, "2023年3月": 155.57387 }, { "机器人": "", "type": "成品糖产量_累计值(万吨)", "2024年3月": 774.4, "2024年2月": 539.90651, "2024年1月": 0, "2023年12月": 1270.55518, "2023年11月": 1000.8, "2023年10月": 907.5, "2023年9月": 843.4, "2023年8月": 820.2, "2023年7月": 804.5, "2023年6月": 784, "2023年5月": 747.9, "2023年4月": 721.6, "2023年3月": 688.24494 }, { "机器人": "", "type": "鲜、冷藏肉产量_当期值(万吨)", "2024年3月": 339.6, "2024年2月": 0, "2024年1月": 0, "2023年12月": 380.1, "2023年11月": 342.1, "2023年10月": 335.2, "2023年9月": 325.3, "2023年8月": 307.6, "2023年7月": 323.5, "2023年6月": 336.2, "2023年5月": 328.5, "2023年4月": 319.9, "2023年3月": 335.2 }, { "机器人": "", "type": "鲜、冷藏肉产量_累计值(万吨)", "2024年3月": 929.6, "2024年2月": 603.6, "2024年1月": 0, "2023年12月": 3923.5, "2023年11月": 3482.2, "2023年10月": 3131.6, "2023年9月": 2790.3, "2023年8月": 2470.6, "2023年7月": 2165.2, "2023年6月": 1835.8, "2023年5月": 1498.6, "2023年4月": 1177.1, "2023年3月": 910.4 }, { "机器人": "", "type": "乳制品产量_当期值(万吨)", "2024年3月": 239, "2024年2月": 0, "2024年1月": 0, "2023年12月": 254.7, "2023年11月": 256.2, "2023年10月": 268.1, "2023年9月": 271.8, "2023年8月": 257.1, "2023年7月": 245, "2023年6月": 261, "2023年5月": 275.2, "2023年4月": 246.6, "2023年3月": 268.8 }, { "机器人": "", "type": "乳制品产量_累计值(万吨)", "2024年3月": 724.3, "2024年2月": 487.6, "2024年1月": 0, "2023年12月": 3054.6, "2023年11月": 2801.6, "2023年10月": 2555.1, "2023年9月": 2286.2, "2023年8月": 2008.9, "2023年7月": 1757.1, "2023年6月": 1512.1, "2023年5月": 1275.1, "2023年4月": 979.3, "2023年3月": 767.9 }, { "机器人": "", "type": "白酒（折65度，商品量）产量_当期值(万千升)", "2024年3月": 43.2, "2024年2月": 0, "2024年1月": 0, "2023年12月": 54.9, "2023年11月": 46.9, "2023年10月": 41.1, "2023年9月": 42, "2023年8月": 26.8, "2023年7月": 28.7, "2023年6月": 37.8, "2023年5月": 34.7, "2023年4月": 37.4, "2023年3月": 49.8 }, { "机器人": "", "type": "白酒（折65度，商品量）产量_累计值(万千升)", "2024年3月": 125.6, "2024年2月": 82.5, "2024年1月": 0, "2023年12月": 449.2, "2023年11月": 395.8, "2023年10月": 347.8, "2023年9月": 306.6, "2023年8月": 261.8, "2023年7月": 236.7, "2023年6月": 209.7, "2023年5月": 186, "2023年4月": 158.1, "2023年3月": 148.3 }, { "机器人": "", "type": "啤酒产量_当期值(万千升)", "2024年3月": 306.9, "2024年2月": 0, "2024年1月": 0, "2023年12月": 214.8, "2023年11月": 159.7, "2023年10月": 184.7, "2023年9月": 286.6, "2023年8月": 374.4, "2023年7月": 402.4, "2023年6月": 419.7, "2023年5月": 374.6, "2023年4月": 305.9, "2023年3月": 343.3 }, { "机器人": "", "type": "啤酒产量_累计值(万千升)", "2024年3月": 872.1, "2024年2月": 566.6, "2024年1月": 0, "2023年12月": 3555.5, "2023年11月": 3339.8, "2023年10月": 3180.4, "2023年9月": 2993.3, "2023年8月": 2700.8, "2023年7月": 2331.1, "2023年6月": 1928, "2023年5月": 1512.8, "2023年4月": 1141.5, "2023年3月": 852.7 }, { "机器人": "", "type": "葡萄酒产量_当期值(万千升)", "2024年3月": 1.2, "2024年2月": 0, "2024年1月": 0, "2023年12月": 2.2, "2023年11月": 1.5, "2023年10月": 1.1, "2023年9月": 1.5, "2023年8月": 1, "2023年7月": 1, "2023年6月": 1.5, "2023年5月": 1, "2023年4月": 0.9, "2023年3月": 1.6 }, { "机器人": "", "type": "葡萄酒产量_累计值(万千升)", "2024年3月": 3.2, "2024年2月": 2, "2024年1月": 0, "2023年12月": 14.3, "2023年11月": 12.1, "2023年10月": 11.1, "2023年9月": 10, "2023年8月": 8.5, "2023年7月": 7.4, "2023年6月": 6.6, "2023年5月": 5.1, "2023年4月": 4.1, "2023年3月": 3.6 }, { "机器人": "", "type": "葡萄酒产量_当期值(万千升)", "2024年3月": 1.2, "2024年2月": 0, "2024年1月": 0, "2023年12月": 2.2, "2023年11月": 1.5, "2023年10月": 1.1, "2023年9月": 1.5, "2023年8月": 1, "2023年7月": 1, "2023年6月": 1.5, "2023年5月": 1, "2023年4月": 0.9, "2023年3月": 1.6 }, { "机器人": "", "type": "葡萄酒产量_累计值(万千升)", "2024年3月": 3.2, "2024年2月": 2, "2024年1月": 0, "2023年12月": 14.3, "2023年11月": 12.1, "2023年10月": 11.1, "2023年9月": 10, "2023年8月": 8.5, "2023年7月": 7.4, "2023年6月": 6.6, "2023年5月": 5.1, "2023年4月": 4.1, "2023年3月": 3.6 }, { "机器人": "红小鬼", "type": "智能手表产量_当期值(万个)", "2024年3月": 656.7, "2024年2月": 0, "2024年1月": 0, "2023年12月": 604.1, "2023年11月": 607.6, "2023年10月": 601.4, "2023年9月": 772.4, "2023年8月": 586.8, "2023年7月": 736.4, "2023年6月": 790.8, "2023年5月": 557, "2023年4月": 451.4, "2023年3月": 590 }, { "机器人": "", "type": "智能手表产量_累计值(万个)", "2024年3月": 1695.9, "2024年2月": 1042.3, "2024年1月": 0, "2023年12月": 7030.6, "2023年11月": 6426.7, "2023年10月": 5883.8, "2023年9月": 5304.2, "2023年8月": 4537.6, "2023年7月": 3950.4, "2023年6月": 3213.7, "2023年5月": 2313.8, "2023年4月": 1757.8, "2023年3月": 1275 }, { "机器人": "垚小稀", "type": "十种有色金属产量_当期值(万吨)", "2024年3月": 667.2, "2024年2月": 0, "2024年1月": 0, "2023年12月": 658.80775, "2023年11月": 650.4, "2023年10月": 654.7, "2023年9月": 641.6, "2023年8月": 629.3, "2023年7月": 603.2, "2023年6月": 615, "2023年5月": 615.1, "2023年4月": 603.6, "2023年3月": 627.57666 }, { "机器人": "", "type": "十种有色金属产量_累计值(万吨)", "2024年3月": 1945.3, "2024年2月": 1276.87417, "2024年1月": 0, "2023年12月": 7469.81447, "2023年11月": 6796, "2023年10月": 6158.3, "2023年9月": 5501.7, "2023年8月": 4856, "2023年7月": 4232.1, "2023年6月": 3638.3, "2023年5月": 3024.4, "2023年4月": 2413.3, "2023年3月": 1826.26431 }, { "机器人": "", "type": "铅产量_当期值(万吨)", "2024年3月": 71.5, "2024年2月": 0, "2024年1月": 0, "2023年12月": 62.5, "2023年11月": 65.3, "2023年10月": 67.4, "2023年9月": 68.7, "2023年8月": 61.9, "2023年7月": 60.4, "2023年6月": 61.5, "2023年5月": 61.6, "2023年4月": 61.4, "2023年3月": 76.3 }, { "机器人": "", "type": "铅产量_累计值(万吨)", "2024年3月": 189.6, "2024年2月": 117.5, "2024年1月": 0, "2023年12月": 756.4, "2023年11月": 689.5, "2023年10月": 643.2, "2023年9月": 576.1, "2023年8月": 506.9, "2023年7月": 446.7, "2023年6月": 388.3, "2023年5月": 326.9, "2023年4月": 265.7, "2023年3月": 216.5 }, { "机器人": "", "type": "锌产量_当期值(万吨)", "2024年3月": 65.1, "2024年2月": 0, "2024年1月": 0, "2023年12月": 66.1, "2023年11月": 65.8, "2023年10月": 62.6, "2023年9月": 56.9, "2023年8月": 54.5, "2023年7月": 53.2, "2023年6月": 58.1, "2023年5月": 59, "2023年4月": 59.4, "2023年3月": 64.4 }, { "机器人": "", "type": "锌产量_累计值(万吨)", "2024年3月": 189, "2024年2月": 123.9, "2024年1月": 0, "2023年12月": 715.2, "2023年11月": 648.8, "2023年10月": 575.9, "2023年9月": 513.3, "2023年8月": 453.8, "2023年7月": 401.5, "2023年6月": 347.7, "2023年5月": 289.4, "2023年4月": 232.2, "2023年3月": 174.8 }] },
      chanzhijson: { "data": [{ "2014": 36220.29, "2015": 36220.29, "2016": 36220.29, "机器人": "盐小氟", "type": "石油加工、炼焦和核燃料加工业大中型工业企业工业销售产值(现价)(亿元)" }, { "2014": 45470.21, "2015": 45334.41, "2016": 47423.26, "机器人": "", "type": "化学原料和化学制品制造业大中型工业企业工业销售产值(现价)(亿元)" }, { "2014": 870.88, "2015": 983.07, "2016": 1095.66, "机器人": "绿小影", "type": "水的生产和供应业大中型工业企业工业销售产值(现价)(亿元)" }, { "2014": 18431.39, "2015": 14810.29, "2016": 13776.67, "机器人": "铜小铝", "type": "煤炭开采和洗选业大中型工业企业工业销售产值(现价)(亿元)" }, { "2014": 3585.48, "2015": 3795.65, "2016": 4276.03, "机器人": "鲁小班", "type": "家具制造业大中型工业企业工业销售产值(现价)(亿元" }, { "2014": 11892.69, "2015": 13047.95, "2016": 14148.99, "机器人": "牛么么", "type": "食品制造业大中型工业企业工业销售产值(现价)(亿元)" }, { "2014": 27745.08, "2015": 27806.94, "2016": 28478.42, "机器人": "", "type": "农副食品加工业大中型工业企业工业销售产值(现价)(亿元)" }, { "2014": 10120.16, "2015": 10765.8, "2016": 11475.91, "机器人": "", "type": "酒、饮料和精制茶制造业大中型工业企业工业销售产值(现价)(亿元)" }, { "2014": 7295.39, "2015": 7905.4, "2016": 8553.12, "机器人": "红小鬼", "type": "文教、工美、体育和娱乐用品制造业大中型工业企业工业销售产值(现价)(亿元)" }, { "2014": 1305.83, "2015": 1331.03, "2016": 1298.85, "机器人": "垚小稀", "type": "非金属矿物制品业大中型工业企业工业销售产值(现价)(亿元)" }] },
      botjson: { "data": [{ "type": "增速", "盐小氟": "硫酸（折100％）产量_同比增长(%)|硫酸（折100％）产量_累计增长(%)|烧碱（折100％）产量_同比增长(%|烧碱（折100％）产量_累计增长(%)|纯碱（碳酸钠）产量_同比增长(%)|纯碱（碳酸钠）产量_累计增长(%)|乙烯产量_同比增长(%)|乙烯产量_累计增长(%)", "绿小影": "太阳能电池（光伏电池）产量_同比增长(%)|太阳能电池（光伏电池）产量_累计增长(%)", "铜小铝": "|铁矿石原矿产量_同比增长(%)|铁矿石原矿产量_累计增长(%)|夹层玻璃产量_同比增长(%)|夹层玻璃产量_累计增长(%)|中空玻璃产量_同比增长(%)|中空玻璃产量_累计增长(%|原盐产量_同比增长(%)|原盐产量_累计增长(%)|生铁产量_同比增长(%)|生铁产量_累计增长(%)|粗钢产量_同比增长(%)|钢材产量_同比增长(%)|钢材产量_累计增长(%)|钢筋产量_同比增长(%)|钢筋产量_累计增长(%)|线材（盘条）产量_同比增长(%)|线材（盘条）产量_累计增长(%)|焊接钢管产量_同比增长(%)|焊接钢管产量_累计增长(%)|铁合金产量_同比增长(%)|铁合金产量_累计增长(%)|氧化铝产量_同比增长(%)|氧化铝产量_累计增长(%)|精炼铜（电解铜）产量_同比增长(%)|原铝（电解铝）产量_同比增长(%)|原铝（电解铝）产量_累计增长(%)|铝合金产量_同比增长(%)|铝合金产量_累计增长(%)|铜材产量_同比增长(%|铜材产量_累计增长(%)|铝材产量_同比增长(%)|铝材产量_累计增长(%)", "鲁小班": "家用电冰箱（家用冷冻冷藏箱）产量_同比增长(%)|家用电冰箱（家用冷冻冷藏箱）产量_累计增长(%)|蚕丝及交织机织物（含蚕丝≥30％）产量_同比增长(%)|蚕丝及交织机织物（含蚕丝≥30％）产量_累计增长(%)|家用冷柜（家用冷冻箱）产量_同比增长(%)|家用冷柜（家用冷冻箱）产量_累计增长(%)|房间空气调节器产量_同比增长(%)|房间空气调节器产量_累计增长(%)|家用洗衣机产量_同比增长(%)|家用洗衣机产量_累计增长(%)", "牛么么": "饲料产量_同比增长|饲料产量_累计增长(%)|精制食用植物油产量_同比增长(%)|精制食用植物油产量_累计增长(%)|成品糖产量_同比增长(%)|成品糖产量_累计增长(%)|鲜、冷藏肉产量_同比增长(%)|鲜、冷藏肉产量_累计增长(%)|乳制品产量_同比增长(%)|乳制品产量_累计增长(%)|白酒（折65度，商品量）产量_同比增长(%)|白酒（折65度，商品量）产量_累计增长(%)|啤酒产量_同比增长(%)|啤酒产量_累计增长(%)|葡萄酒产量_同比增长(%|葡萄酒产量_累计增长(%)|饮料产量_同比增长(%)|饮料产量_累计增长(%)", "红小鬼": "智能手表产量_同比增长(%)|智能手表产量_累计增长(%)", "垚小稀": "十种有色金属产量_同比增长(%)|十种有色金属产量_累计增长(%)|铅产量_同比增长(%)|铅产量_累计增长(%)|锌产量_同比增长(%|锌产量_累计增长(%)" }, { "type": "产量", "盐小氟": "硫酸（折100％）产量)|硫酸（折100％）产量|烧碱（折100％）产量|烧碱（折100％）产量|纯碱（碳酸钠）产量|纯碱（碳酸钠）产量|乙烯产量|乙烯产量", "绿小影": "太阳能电池（光伏电池）产量|太阳能电池（光伏电池）产量", "铜小铝": "|铁矿石原矿产量|铁矿石原矿产量|夹层玻璃产量|夹层玻璃产量|中空玻璃产量|中空玻璃产量|原盐产量|原盐产量|生铁产量|生铁产量|粗钢产量|钢材产量|钢材产量|钢筋产量|钢筋产量|线材（盘条）产量|线材（盘条）产量|焊接钢管产量|焊接钢管产量|铁合金产量|铁合金产量|氧化铝产量|氧化铝产量|精炼铜（电解铜）产量|原铝（电解铝）产量|原铝（电解铝）产量|铝合金产量|铝合金产量|铜材产量|铜材产量|铝材产量|铝材产量", "鲁小班": "家用电冰箱（家用冷冻冷藏箱）产量_同比增长(%)|家用电冰箱（家用冷冻冷藏箱）产量_累计增长(%)|蚕丝及交织机织物（含蚕丝≥30％）产量_同比增长(%)|蚕丝及交织机织物（含蚕丝≥30％）产量_累计增长(%)|家用冷柜（家用冷冻箱）产量_同比增长(%)|家用冷柜（家用冷冻箱）产量_累计增长(%)|房间空气调节器产量_同比增长(%)|房间空气调节器产量_累计增长(%)|家用洗衣机产量_同比增长(%)|家用洗衣机产量_累计增长(%)", "牛么么": "饲料产量|饲料产量|精制食用植物油产量|精制食用植物油产量|成品糖产量|成品糖产量|鲜、冷藏肉产量|鲜、冷藏肉产量|乳制品产量|乳制品产量|白酒（折65度，商品量）产量|白酒（折65度，商品量）产量|啤酒产量|啤酒产量|葡萄酒产量|葡萄酒产量|饮料产量|饮料产量", "红小鬼": "智能手表产量|智能手表产量", "垚小稀": "十种有色金属产量|十种有色金属产量|铅产量_同比增长|铅产量_累计增长|锌产量_同比增长|锌产量_累计增长" }, { "type": "产值", "盐小氟": "石油加工、炼焦和核燃料加工业大中型工业企业工业销售产值(现价)(亿元)|化学原料和化学制品制造业大中型工业企业工业销售产值(现价)(亿元)", "绿小影": "水的生产和供应业大中型工业企业工业销售产值(现价)(亿元)", "铜小铝": "煤炭开采和洗选业大中型工业企业工业销售产值(现价)(亿元)", "鲁小班": "家具制造业大中型工业企业工业销售产值(现价)(亿元", "牛么么": "食品制造业大中型工业企业工业销售产值(现价)(亿元)|农副食品加工业大中型工业企业工业销售产值(现价)(亿元)|酒、饮料和精制茶制造业大中型工业企业工业销售产值(现价)(亿元)", "红小鬼": "文教、工美、体育和娱乐用品制造业大中型工业企业工业销售产值(现价)(亿元)", "垚小稀": "非金属矿物制品业大中型工业企业工业销售产值(现价)(亿元)" }] },
      chanliangvalue: [],
      chanzhivalue: [],
      zengsuvalue: [],
      warnum: 0,
      lxytabledata: [],
      timetype: 'day',
      lxytimetype: '2',
      etime: '',
      stime: '',
      wzlist: [],
      realtime: false,
      realtimedata: null,
      lxytime: formatTime(new Date(new Date().getTime() - 86400000), 'YYYY-MM-DD'),
      barchart: []
    }
  },
  props: {
    aiboxitem: { type: Object, default: () => [] },
  },
  mounted() {
    this.etime = formatTime(new Date(), 'YYYY-MM-DD')
    this.stime = formatTime(new Date(new Date().getTime() - 86400000), 'YYYY-MM-DD')
    // this.createpiechart()
    console.log('产量', this.chanliangjson)
    console.log('产值', this.chanzhijson)
    console.log('增速', this.zengsujson)
    console.log('机器人', this.botjson)
    this.getGboxdata()
    this.getwardata()
    this.getaicount()
    if (this.aibox.name == '晓知因') {
      this.cprice1()
      this.createmap()
    } else if (this.aibox.name == '绿小影') {
      this.getlxyrank();
      this.getwzlist()
    } else {
      this.getbotdatreport()
    }
    const domW = window.getComputedStyle(this.$refs.spacePie).width
    const gboxCanvas = document.querySelector('#gboxcharts')
    const cboxCanvas = document.querySelector('#cboxcharts')
    gboxCanvas.style.width = domW
    cboxCanvas.style.width = domW
  },
  watch: {
    aiboxitem(n) {
      // console.log(n, 'data')
      this.aibox = n;
    }
  },
  methods: {
    realtimechange() {
      console.log(this.realtime)
      if (this.realtime) {
        this.realtimedata = setInterval(() => {
          this.getGboxdata()
          this.getwardata()
        }, 1000);
      } else {
        clearInterval(this.realtimedata)
        this.realtimedata = null
      }
    },
    smenuclick(e) {
      this.smenu = e
    },
    timetypeclick(e) {

      this.stime = e == 'day' ? formatTime(new Date(new Date().getTime() - 86400000), 'YYYY-MM-DD') : e == 'month' ? formatTime(new Date(), 'YYYY-MM-01') : formatTime(new Date(), 'YYYY-01-01');
      this.timetype = e
      setTimeout(() => {
        this.getwardata()
        this.getaicount()
        this.getGboxdata()
      }, 200);
    },
    lxytimechange(e) {
      if (new Date(e.target.value) > new Date()) {
        this.$message.error('请选择正确的时间')
        return;
      }
      console.log(e.target.value)
      this.lxytime = e.target.value
      setTimeout(() => {
        this.getlxyrank()
      }, 200);
    },
    openweb(e) {
      window.open(e)
    },
    lxytimeclick(e) {
      this.lxytimetype = e
      setTimeout(() => {
        this.getlxyrank()
      }, 200);
    },
    getwzlist() {

      getLxyWzData().then(res => {
        console.log('绿小影文章接口', res)
        this.wzlist = res.data
      })
    },
    getlxyrank() {
      const params = `data_type=5&time=${this.lxytime}&time_type=${this.lxytimetype}&type=8`
      getRank(params).then(res => {
        console.log('绿小影排名', res)
        this.lxytabledata = res.data
      })

    },
    getbotdatreport() {
      this.getgoodsprice()
      //产量
      const cltypelist = this.botjson.data[1][this.aibox.name] ? this.botjson.data[1][this.aibox.name].split('|') : []
      const sjtype = cltypelist[Math.floor(Math.random() * ((cltypelist.length - 1) - 0 + 1)) + 0];
      const clvalue = this.chanliangjson.data.filter(item => item.type.includes(sjtype) && item.type.includes('当期值'))
      this.chanliangvalue = {
        name: sjtype,
        value: clvalue[0]
      }
      //产值
      const cztypelist = this.botjson.data[2][this.aibox.name] ? this.botjson.data[2][this.aibox.name].split('|') : []
      const sjtype2 = cztypelist[Math.floor(Math.random() * ((cztypelist.length - 1) - 0 + 1)) + 0];
      const czvalue = this.chanzhijson.data.filter(item => item.type.includes(sjtype2))
      this.chanzhivalue = {
        name: sjtype2,
        value: czvalue[0]
      }
      //增速
      const zstypelist = this.botjson.data[0][this.aibox.name] ? this.botjson.data[0][this.aibox.name].split('|') : []
      const sjtype3 = zstypelist[Math.floor(Math.random() * ((zstypelist.length - 1) - 0 + 1)) + 0];
      const zsvalue = this.zengsujson.data.filter(item => item.type.includes(sjtype3))
      this.zengsuvalue = {
        name: sjtype3,
        value: zsvalue[0]
      }

      setTimeout(() => {

        this.createzengsuchart(zsvalue[0])
      }, 500);

    },
    openpdf(e) {
      window.open(e)
    },
    getgoodsprice() {
      getGoodsPrice(formatTime(new Date(), 'YYYY-MM-DD')).then(res => {
        console.log('price', res)
        this.priceitem = res.data[Math.floor(Math.random() * ((res.data.length - 1) - 0 + 1)) + 0];
        console.log(this.priceitem)
      })

    },
    getwardata() {
      const xhr = new XMLHttpRequest()
      const that = this
      const starttime = this.timetype == 'day' ? formatTime(new Date(new Date().getTime() - 86400000), 'YYYY-MM-DD') : this.timetype == 'month' ? formatTime(new Date(), 'YYYY-MM-01') : formatTime(new Date(), 'YYYY-01-01');
      xhr.open('POST', baseUrl + '/warnapi/cgbox/warnCount')
      xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr.setRequestHeader("Content-type", "application/json");
      xhr.send(JSON.stringify({ timeType: that.timetype, startTime: starttime, endTime: formatTime(new Date(), 'YYYY-MM-DD') }));
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {  //固定写法
          //数据获取成功，获取服务器响应的数据
          const res = JSON.parse(xhr.responseText)
          that.warnum = res.data
        }
      }
    },
    getGboxdata() {
      let xhr = new XMLHttpRequest()
      const that = this;
      // const starttime = this.timetype == 'day' ? formatTime(new Date(new Date().getTime() - 86400000), 'YYYY-MM-DD hh:mm:ss') : this.timetype == 'month' ? formatTime(new Date(new Date().getTime() - 86400000 * 30), 'YYYY-MM-DD') : formatTime(new Date(new Date().getTime() - 86400000 * 365), 'YYYY-MM-DD');
      xhr.open('POST', baseUrl + '/api/cgboxDevice/aiBookLog');
      xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr.setRequestHeader("Content-type", "application/json");
      xhr.send(JSON.stringify({ timeType: that.timetype, startTime: '', endTime: '' }));
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {  //固定写法
          //数据获取成功，获取服务器响应的数据
          const res = JSON.parse(xhr.responseText)
          console.log('bb', res.data)
          that.aizblist = res.data
        }
      }

      let xhr3 = new XMLHttpRequest()
      xhr3.open('POST', baseUrl + '/api/index/aiLog')
      xhr3.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr3.setRequestHeader("Content-type", "application/json");
      xhr3.setRequestHeader('Authorization', localStorage.getItem("token"))
      xhr3.send(JSON.stringify({ timeType: that.timetype, startTime: '', endTime: '' }));
      // xhr3.send(JSON.stringify({ timeType: that.timetype, startTime: starttime, endTime: formatTime(new Date(), 'YYYY-MM-DD hh:mm:ss') }));
      // xhr3.send();
      xhr3.onreadystatechange = function () {
        if (xhr3.readyState === 4 && xhr3.status === 200) {  //固定写法
          //数据获取成功，获取服务器响应的数据
          const res = JSON.parse(xhr3.responseText)
          that.newaiData = res.data
          console.log('1111111111111111');
        }
      }


      const off = {
        normal: {
          color: new echarts.graphic.LinearGradient(
            1, 1, 1, 0,
            [
              { offset: 0, color: '#ae0ef0' },
              { offset: 1, color: '#f81b9a' },
            ]
          )
        }

      }
      const on = {
        normal: {
          color: new echarts.graphic.LinearGradient(
            1, 1, 1, 0,
            [
              { offset: 0, color: '#0edff0' },
              { offset: 1, color: '#1b36f8' },
            ]
          )
        }
      }
      let xhr2 = new XMLHttpRequest()
      xhr2.open('POST', baseUrl + '/api/cgboxDevice/statusChart')
      xhr2.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr2.setRequestHeader("Content-type", "application/json");
      xhr2.send(JSON.stringify({ timeType: that.timetype, startTime: '', endTime: '' }));
      xhr2.onreadystatechange = function () {
        if (xhr2.readyState === 4 && xhr2.status === 200) {  //固定写法
          //数据获取成功，获取服务器响应的数据
          const res = JSON.parse(xhr2.responseText)
          that.aizbcharts = res.data;
          console.log('chart', res.data)
          that.createpiechart(0, [{
            name: '在线数', value: res.data.gboxRunStatusChartVO.normalCount, itemStyle: on
          }, {
            name: '离线数', value: res.data.gboxRunStatusChartVO.offlineCount, itemStyle: off
          }])
          that.createpiechart(1, [{
            name: '在线数', value: res.data.cboxRunStatusChartVO.normalCount, itemStyle: on
          }, { name: '离线数', value: res.data.cboxRunStatusChartVO.offlineCount, itemStyle: off }])

        }
      }
      let xhr4 = new XMLHttpRequest()
      xhr4.open('GET', baseUrl + '/klgapi/knowledge_base/getwxrobotstat')
      xhr4.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr4.setRequestHeader("Content-type", "application/json");
      xhr4.send();
      xhr4.onreadystatechange = function () {
        if (xhr4.readyState === 4 && xhr4.status === 200) {  //固定写法
          //数据获取成功，获取服务器响应的数据
          const res = JSON.parse(xhr4.responseText)
          // that.aizbcharts = res.data;
          console.log('chart', res.data)
          that.createpiechart(2, [{
            name: '在线数', value: res.online, itemStyle: on
          }, { name: '离线数', value: res.offline, itemStyle: off }])
        }
      }

    },
    getaicount() {
      let xhr = new XMLHttpRequest()
      xhr.open('GET', baseUrl + '/klgapi/knowledge_base/getstat?mode=' + this.aibox.name + '&type=' + (this.timetype == 'day' ? '日' : this.timetype == 'year' ? '年' : '月'))
      xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr.setRequestHeader("Content-type", "application/json");
      xhr.send();
      const that = this;
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {  //固定写法
          //数据获取成功，获取服务器响应的数据
          const res = JSON.parse(xhr.responseText)
          that.aicount = res;
          console.log('aa', res)
          const aidata = []
          res.sources.forEach(item => {
            if (that.aibox.name == '晓知因') {
              if (item.source == '晓知因') {
                that.hotai = item
              }
            } else {
              that.hotai = item
            }
            if (item.source == that.aibox.name) {
              that.thisaibotcount = item
            }
          })
          res.words.forEach((item, i) => {
            aidata.push({
              name: item.word,
              value: parseInt(item.num) * 100
            })
          });
          that.createciyun(aidata)
        }
      }
    },
    createciyun(data) {
      const myChart = echarts.init(document.getElementById('container'));
      const option = {
        grid: {
          left: 10,
          right: 10,
          top: 10,
          bottom: 10,
          containLabel: true
        },
        series: [
          {
            type: 'wordCloud',
            gridSize: 1,
            sizeRange: [12, 70],
            rotationRange: [20, 0],
            shape: 'pentagon',
            textStyle: {
              color: function () {
                return (
                  'rgb(' + Math.round(Math.random() * 255) + ', ' + Math.round(Math.random() * 255) + ', ' + Math.round(Math.random() * 255) + ')'
                );
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: '#333',
              },
            },
            data: data,
          },
        ],
      };
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    },
    createpiechart(i, data) {
      // prettier-ignore

      const barchart = echarts.init(document.getElementsByClassName('barcharts')[i]);
      const option = {
        tooltip: {
          trigger: 'item'
        },
        grid: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        },
        legend: {
          bottom: '0%',
          left: 'center',
          textStyle: {
            color: '#333'
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                color: '#333',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      };
      barchart.setOption(option);

    },
    createzengsuchart(data) {
      if (!data) {
        return;
      }
      console.log('chartvalue', data)
      const newkeys = [];
      Object.keys(data).forEach(item => {
        console.log(item)
        if (item.includes('月')) {
          newkeys.push(item)
        }
      })
      const newdata = [];
      newkeys.forEach(item => {
        newdata.push(data[item])
      })
      // data.sort((a, b) => a - b)
      console.log('chartvalue', newdata)
      const myChart = echarts.init(document.getElementById('price3'));
      const option = {
        title: {
          text: ''
        },
        grid: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },

        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: ['2024年3月', '2024年2月', '2024年1月', '2023年12月', '2023年11月', '2023年10月', '2023年9月', '2023年8月', '2023年7月', '2023年6月', '2023年5月', '2023年4月', '2023年3月']
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: '增速(%)',
            type: 'line',
            smooth: true,
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(255, 70, 131)'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 158, 68)'
                },
                {
                  offset: 1,
                  color: 'rgb(255, 70, 131)'
                }
              ])
            },
            data: newdata
          },
        ]
      };
      myChart.setOption(option);
    },
    cprice1() {
      const myChart = echarts.init(document.getElementById('price1'));
      const option = {
        title: {
          text: ''
        },
        grid: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },

        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: ['2024年3月', '2024年2月', '2024年1月', '2023年12月', '2023年11月', '2023年10月', '2023年9月', '2023年8月', '2023年7月', '2023年6月', '2023年5月', '2023年4月']
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
          },
          min: 0,
          max: 8,
        },
        series: [
          {
            name: '经济增速(%)',
            type: 'line',
            smooth: true,
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(255, 70, 131)'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 158, 68)'
                },
                {
                  offset: 1,
                  color: 'rgb(255, 70, 131)'
                }
              ])
            },
            data: [4.5, 0, 6.8, 6.6, 4.6, 4.5, 4.5, 3.7, 4.4, 3.5, 5.6, 3.9]
          },
        ]
      };
      myChart.setOption(option);
    },
    createmap() {
      const myChart = echarts.init(document.getElementById('suanlimap'));
      const option = {
        visualMap: {
          show: false,
          type: 'continuous',
          calculable: true,
          left: '0%',
          bottom: '3%',
          dimension: 0, // 指定用数据的『哪个维度』，映射到视觉元素上。『数据』即 series.data。 可以把 series.data 理解成一个二维数组,其中每个列是一个维度,默认取 data 中最后一个维度
          seriesIndex: 1,
          itemWidth: 15, // 图形的宽度，即长条的宽度。
          itemHeight: 68,
          min: 0,
          // max: that.mapmax,
          // color: ['#01fffd', '#1E74FF'],
          // color: ['#0B64F3', '#1A05B8'],
          color: ['#007EF9 ', '#0B275E'],
          textStyle: {
            color: '#ccc',
            fontSize: 12
          }
        },
        tooltip: {
          // 轮播框
          enterable: true,
          transitionDuration: 1,
          textStyle: {
            fontFamily: 'Microsoft YaHei',
            color: '#b8c8e5',
            fontSize: 13
          },
          backgroundColor: 'rgba(15,33,70,0.7)',
          borderColor: '',
          borderWidth: 1,
          padding: [10, 14],
          extraCssText: 'z-index:4',
          formatter: function (parma) {
            if (parma.seriesType === 'effectScatter') {
              return parma.name
            } else {
              return parma.name
            }
          }
        },
        legend: {
          show: false,
          color: ['#5bffde'],
          icon: 'circle', // 只显示小圆点

          top: '10.7%',
          // bottom: '2.8%',
          left: '2%',
          itemGap: 22,
          itemWidth: 8, // 图例图形宽度
          textStyle: {
            color: '#333',
            fontSize: 14,
            fontWeight: 'normal',
            // align: "left",
            padding: [0, 3],
            fontFamily: 'Microsoft YaHei'
          },
          itemHeight: 8 // 改变圆圈大小
        },
        geo: {
          zoom: 1.25, // 缩放比例
          top: '11%',
          left: '10%',
          show: true,
          aspectScale: 0.85,
          silent: true, // 鼠标事件是否开启
          animation: true,
          map: 'china',
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          roam: false, //是否可缩放
          //  aspectScale: 1, //长宽比
          // 这里是重点！！！
          regions: [
            {
              name: '南海诸岛',
              itemStyle: {
                // 隐藏地图
                normal: {
                  opacity: 0 // 为 0 时不绘制该图形
                }
              },
              label: {
                show: false // 隐藏文字
              }
            }
          ],

          itemStyle: {
            normal: {
              // areaColor: '#122C69', // #415ef7
              borderColor: 'blue',
              shadowColor: '',
              shadowOffsetX: 1,
              shadowOffsetY: 9
              // borderWidth: 3,
            },
            emphasis: {
              areaColor: '#4499d0'
            }
          }
        },
        series: [
          {
            name: '背景地图',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            symbolSize: function () {
              return 8
            },
            // data: mapData,
            data: [],
            rippleEffect: {
              period: 4,
              scale: 1.5,
              brushType: 'stroke'
            },
            label: {
              normal: {
                formatter: '{b}',
                position: 'bottom',
                show: false
              },
              emphasis: {
                show: false
              }
            },
            showEffectOn: 'render',
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: '#5bffde' // 点的颜色
              },
              label: {
                show: false
              },
            },
            zlevel: 1
          },
          {
            // 真的地图
            type: 'map',
            map: 'china',
            geoIndex: 1,
            zoom: 1.25, // 缩放比例
            top: '11%',
            left: '10%',
            aspectScale: 0.85, // 长宽比
            showLegendSymbol: true, // 存在legend时显示
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: '#333'
                }
              }
            },
            roam: false,
            itemStyle: {
              normal: {
                color: 'none',
                areaColor: '#122C69', //'#01032a',
                borderColor: '#3089f8', // 4065eb
                borderWidth: 1
              },
              emphasis: {
                areaColor: 'orange'
              }
            },
            select: {
              // 选中时样式
              label: {
                color: '#333'
              },
              itemStyle: {
                areaColor: 'blue'
              }
            },
            animation: true,

            data: [
              { name: '北京', selected: false, value: 1 },
              { name: '天津', selected: false, value: 2 },
              { name: '上海', selected: false, value: 3 },
              { name: '重庆', selected: false, value: 4 },
              { name: '河北', selected: false, value: 5 },
              { name: '河南', selected: false, value: 6 },
              { name: '江苏', selected: false, value: 14 },
              { name: '浙江', selected: false, value: 15 },
              { name: '江西', selected: false, value: 16 },
              { name: '湖北', selected: false, value: 17 },
              { name: '广东', selected: false, value: 26 }
            ]
            // data: that.maparr
          },
          {
            name: '大点',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            symbolSize: function () {
              return 14
            },

            rippleEffect: {
              period: 4,
              scale: 1.5,
              brushType: 'stroke'
            },
            label: {
              normal: {
                formatter: '{b}',
                position: 'bottom',
                show: false
              },
              emphasis: {
                show: false
              }
            },
            showEffectOn: 'render',
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: '#5bffde' // 点的颜色
              },
              label: {
                show: false
              },
            },
            zlevel: 2
          },
          {
            type: 'lines',
            zlevel: 1,
            effect: {
              show: true,
              period: 6, //箭头指向速度，值越小速度越快
              trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: 'arrow', //箭头图标
              symbolSize: 6 //图标大小
            },
            label: {
              emphasis: {
                show: false
              }
            },
            lineStyle: {
              normal: {
                width: 1, //尾迹线条宽度
                color: '#27C7E9',
                opacity: 1, //尾迹线条透明度
                curveness: 0.3 //尾迹线条曲直度
              }
            },
            data: [
              [
                {    // 第一个起点的经纬度配置
                  coord: ['119.946973', '31.772752'],
                  value: "0000100101"
                },
                {
                  coord: ['113.746262', '23.046237'] // 跟上面的广东那一层的经纬度对应
                }
              ],
            ]
          },

        ],
        dataRange: {
          x: '-1000 px', //图例横轴位置
          y: '-1000 px', //图例纵轴位置
          splitList: [
            { start: 1, end: 1, label: '北京', color: '#2b53e9' },
            { start: 2, end: 2, label: '天津', color: '#2b53e9' },
            { start: 3, end: 3, label: '上海', color: '#2b53e9' },
            { start: 4, end: 4, label: '重庆', color: '#2b53e9' },
            { start: 5, end: 5, label: '河北', color: '#2b53e9' },
            { start: 6, end: 6, label: '河南', color: '#2b53e9' },
            { start: 14, end: 14, label: '江苏', color: '#2b53e9' },
            { start: 15, end: 15, label: '浙江', color: '#2b53e9' },
            { start: 16, end: 16, label: '江西', color: '#2b53e9' },
            { start: 17, end: 17, label: '湖北', color: '#2b53e9' },
            { start: 26, end: 26, label: '广东', color: '#2b53e9' },
          ]
        }
      }
      echarts.registerMap('china', chinaCityJson)
      myChart.setOption(option)
    },
    chartChange(value) {
      console.log(window.getComputedStyle(this.$refs.spacePie).width, value)
      const domW = window.getComputedStyle(this.$refs.spacePie).width
      // if (value == '0') {
      //   this.barchart[1].setOption({
      //     grid: {
      //       left: 0,
      //       top: 0,
      //       right: 0,
      //       bottom: 0,
      //       width: domW
      //     }
      //   })
      // } else {
      //   this.barchart[0].setOption({
      //     grid: {
      //       left: 0,
      //       top: 0,
      //       right: 0,
      //       bottom: 0,
      //       width: domW
      //     }
      //   })
      // }
      // this.barchart.resize()
      // this.barchart.setOption({
      //   grid: {
      //     left: 0,
      //     top: 0,
      //     right: 0,
      //     bottom: 0,
      //     width: domW
      //   }
      // })
    }

  }
}
</script>
<style lang='less' scoped>
.homemain {
  width: 100%;
  height: 100%;
  border-radius: 10px 0 0 10px;
  display: flex;

  .home-left {
    width: calc(100% - 500px);
    height: 100%;
    padding: 20px;
    color: #fff;
    padding-right: 0;

    .left-top {
      width: 100%;
      height: 66%;

      .top_title {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: space-between;

        .titlebox,
        .datebox {
          width: 50%;
        }

        .titlebox {
          font-size: 22px;
          display: flex;
          color: #333;

          .titlepoint {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #3089f8;
            margin: 10px;
          }
        }

        .datebox {
          display: flex;
          justify-content: flex-end;
          color: #333;

          .timebox {
            font-size: 16px;
            height: 40px;
            line-height: 30px;
            margin-right: 20px;
          }

          .realdatabox {
            font-size: 16px;
            height: 30px;
            display: flex;
            align-items: center;
            margin-right: 20px;

            span {
              margin-right: 10px;
            }
          }

          .dateitem {
            width: 30px;
            height: 30px;
            background-color: #a49bbf2e;
            line-height: 30px;
            text-align: center;
            margin: 0 4px;
            border-radius: 6px;
            cursor: pointer;
            color: #3089f8;
          }

          .dated {
            background-color: #3089f8;
            color: white;
          }
        }
      }

      .tipcont {
        width: 100%;
        height: calc(100% - 70px);
        display: flex;
        flex-wrap: wrap;

        .tipleft {
          width: calc(66.66% - 0px);
          height: 100%;
          display: flex;
          flex-wrap: wrap;

          .contitem {
            width: calc(20% - 20px);
            height: calc(33.3% - 10px);
            background-color: #fff;
            box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            padding: 20px;
            margin-bottom: 10px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            flex-wrap: wrap;

            .name {
              font-family: Alibaba PuHuiTi;
              font-size: 14px;
              color: #333;
            }

            .num {
              width: 100%;
              font-size: 28px;
              font-weight: bolder;

              span {
                font-size: 22px;
                padding-left: 5px;
              }
            }

            .c1 {
              background: linear-gradient(to right, #9953ff, #53a9ff);
              /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
              -webkit-background-clip: text;
              /*将设置的背景颜色限制在文字中*/
              -webkit-text-fill-color: transparent;
            }

            .c2 {
              color: #17ffa6 !important;
            }

            .c3 {
              color: #3089f8 !important;
            }

            .s {
              font-size: 16px;
              color: white;

              span {
                color: #e0e0e0;
                font-size: 14px;
                margin-left: 5px;
              }
            }

            .barcharts {
              height: 170px;
              width: 100%;
              margin-top: -20px;
            }

            .godetail {
              margin-top: 5px;
              font-size: 13px;
              color: #3089f8;
              cursor: pointer;
            }

            .gs {
              margin-top: 10px;
              font-size: 15px;
              color: #3089f8;
              cursor: pointer;
            }
          }

          .contitemo {
            width: calc(25% - 20px);
            background: #fff;
            box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.1);
            border-radius: 7px;
            color: #333;


            .onum {
              font-size: 30px;
              font-weight: bolder;
              text-align: center;
              width: 100%;
            }

            .oname {
              font-family: Alibaba PuHuiTi;
              font-size: 16px;
              text-align: center;
              color: #3089f8;
              width: 100%;
            }

            .ogodetail {
              width: 99px;
              height: 22px;
              background: #ffffff20;
              border-radius: 4px;
              text-align: center;
              margin: 0 auto;
              line-height: 22px;
              margin-top: 15px;
            }
          }
        }

        .tipright {
          width: 33.3%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;

          .contitem {
            position: relative;
            width: calc(100% - 10px);
            height: calc(50% - 10px);
            background-color: #fff;
            box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            padding: 20px;
            margin-bottom: 20px;

            .pir-wrapper {
              width: 100%;
            }

            .tip {
              position: absolute;
              right: 20px;
              top: 10px;
            }

            .name {
              font-family: Alibaba PuHuiTi;
              font-size: 18px;
              color: #333;
            }
          }
        }

        .contitem {
          width: calc(25% - 20px);
          height: 210px;
          background-color: #fff;
          box-shadow: 2px 3px 6px #fff;
          border-radius: 8px;
          padding: 20px;
          margin: 10px;

          .name {
            font-family: Alibaba PuHuiTi;
            font-size: 18px;
            color: #333;
          }

          .num {
            margin-top: 10px;

            font-size: 50px;
            font-weight: bolder;

            span {
              font-size: 22px;
              padding-left: 5px;
            }
          }

          .c1 {
            background: linear-gradient(to right, #9953ff, #53a9ff);
            /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
            -webkit-background-clip: text;
            /*将设置的背景颜色限制在文字中*/
            -webkit-text-fill-color: transparent;
          }

          .c2 {
            color: #17ffa6 !important;
          }

          .c3 {
            color: #3089f8 !important;
          }

          .s {
            font-size: 16px;
            color: white;

            span {
              color: #e0e0e0;
              font-size: 14px;
              margin-left: 5px;
            }
          }

          .barcharts {
            height: 170px;
            width: 100%;
            margin-top: -20px;
          }

          .godetail {
            margin-top: 40px;
            font-size: 15px;
            color: #3089f8;
            cursor: pointer;
          }

          .gs {
            margin-top: 10px;
            font-size: 15px;
            color: #3089f8;
            cursor: pointer;
          }
        }

        .nl {
          background: none;
        }
      }
    }

    .left_bottom {
      width: 100%;
      display: flex;
      margin-top: 10px;

      .bottom_item {
        width: 33.3%;
        height: 300px;
        margin: 10px;

        .titlebox {
          font-size: 22px;
          display: flex;
          color: #333;

          .titlepoint {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #3089f8;
            margin: 10px;
          }
        }

        .botcontent {
          width: 100%;
          height: 260px;
          margin-top: 10px;
          background-color: #fff;
          box-shadow: 2px 3px 6px #fff;
          border-radius: 8px;
        }
      }

      .xzy .botcontent {
        .aibothead {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .head {
            margin: 50px 20px;
            width: 80px;
            height: 80px;
            border-radius: 50%;


            position: relative;

            img {
              position: absolute;
              left: -25px;
              top: -30px;
              width: 120px;
              clip-path: polygon(0 -220px, 2000px 158px, 14px 109px, 13px 11px);
            }
          }

          .name {
            color: #333;
            font-family: Alibaba PuHuiTi;

            .nametxt {
              color: #333;
              font-size: 20px;
              font-weight: bolder;
            }
          }
        }

        .aibotcont {
          width: 100%;
          display: flex;

          .contitem {
            width: 33.3%;
            text-align: center;

            .name {
              font-family: Alibaba PuHuiTi;
              color: #333;
              font-size: 18px;
              display: flex;

              .namepoint {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #3089f8;
                margin: 8px;
                margin-bottom: 15px;
              }
            }

            .num {
              font-size: 18px;
              color: #333;
              text-align: center;

              span {
                color: #33333390;
                font-size: 12px;
                margin-left: 5px;
              }
            }
          }
        }
      }

      .hot .botcontent {
        overflow-y: auto;

        .hotitem {
          display: flex;
          padding: 15px;
          padding-bottom: 8px;
          justify-content: space-around;
          align-items: center;
          align-content: center;

          .l1 {
            width: 20px;
            height: 20px;
            line-height: 20px;
            background-color: #d12525;
            display: flex;
            align-items: center;
            justify-content: center;

            clip-path: polygon(50% 0%,
                100% 25%,
                100% 75%,
                50% 100%,
                0% 75%,
                0% 25%);
          }

          .name {
            font-family: Alibaba PuHuiTi;
            width: 50%;
            font-size: 16px;
            margin: 0 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #333;
          }

          .ratio {
            font-size: 14px;
            color: #333;
          }

          .u-d {
            svg {
              height: 20px;
            }
          }
        }
      }

      .ciyun .botcontent {
        width: 100%;
        height: calc(100% - 40px);

        #container {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .home_right {
    width: 500px;
    color: white;
    padding: 20px;

    .righttop {
      height: 66%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-content: flex-start;
      align-items: flex-start;

      .slmap {
        height: 300px;
        width: calc(100% - 20px);
        padding: 10px;

        margin: 10px;
        margin-top: 20px;
        background-color: #fff;
        box-shadow: 2px 3px 6px #fff;
        border-radius: 8px;
      }

      .titlebox,
      .datebox {
        width: 100%;
        height: 30px;
      }

      .titlebox {
        font-size: 22px;
        display: flex;
        width: 100%;
        color: #333;

        .titlepoint {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #3089f8;
          margin: 10px;
        }
      }

      .contitem {
        width: calc(50% - 20px);
        height: 200px;
        background-color: #fff;
        box-shadow: 2px 3px 6px #fff;
        border-radius: 8px;
        padding: 10px;

        margin: 10px;

        .name {
          font-size: 18px;
          display: flex;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #333;
          line-height: 22px;

          .namepoint {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #3089f8;
            margin: 8px;
            margin-bottom: 15px;
          }
        }

        .stitle {
          color: #e0e0e0;
          font-size: 14px;
          margin-top: 10px;
        }

        .num {
          font-family: Alibaba PuHuiTi;
          font-size: 28px;
          color: #333;

          span {
            color: #e0e0e0;
            font-size: 14px;
            margin: 0 5px;
          }
        }

        .b {
          font-size: 36px;
          padding: 30px 0;
        }

        .detailchart {
          width: calc(100% - 0px);
          height: 150px;
        }

        .lxytitle {
          width: 100%;
          background: linear-gradient(180deg, #9953ff 0%, #53a9ff 100%);
          /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
          -webkit-background-clip: text;
          /*将设置的背景颜色限制在文字中*/
          -webkit-text-fill-color: transparent;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          img {
            margin-right: 6px;
          }
        }

        .timebox {
          display: flex;
          margin-top: 10px;

          .datebox {
            width: 50%;

            input {
              width: 100%;
              background: transparent;
              border: 1px solid #3089f8;
              border-radius: 6px;
              color: white;
              padding: 3px;
              text-indent: -8px;
            }

            input[type='date']::-webkit-calendar-picker-indicator {
              filter: invert(1);
              margin-left: 0;
            }
          }

          .timetypebox {
            display: flex;
            height: 25px;
            width: 60%;
            justify-content: center;
            align-items: center;

            .timeitem {
              width: 33%;
              height: 25px;
              margin-left: 2px;
              font-size: 14px;
              border-radius: 4px;
              text-align: center;
              background-color: #fff;
              box-shadow: 2px 3px 6px #fff;
              border-radius: 3px;
              line-height: 25px;
              cursor: pointer;
            }

            .ted {
              background: #3089f8;
            }
          }
        }

        .tablebox {
          width: 100%;
          height: calc(100% - 70px);

          .theadbox {
            display: flex;
            width: 100%;
            color: #3089f8;
            font-size: 14px;

            .th {
              width: 25%;
              text-align: center;
            }

            .th:nth-child(1) {
              width: 20%;
            }

            .th:nth-child(4) {
              width: 30%;
            }

            .th:nth-child(5) {
              width: 10%;
            }
          }

          .tbodybox {
            width: calc(100% + 10px);
            height: calc(100% - 25px);
            overflow-y: auto;

            color: #fff;
            font-size: 13px;

            .tr {
              width: 100%;
              height: 20px;
              display: flex;
              cursor: pointer;

              .td {
                width: 25%;
                height: 20px;
                text-align: center;
                text-overflow: hidden;
              }

              .td:nth-child(1) {
                width: 20%;
              }

              .td:nth-child(4) {
                width: 30%;
              }

              .td:nth-child(5) {
                width: 10%;
                text-align: center;

                .moveUp {
                  /*箭头占位符，规定宽高等*/
                  width: 6px;
                  height: 15px;
                  display: inline-block;
                  position: relative;
                  cursor: pointer;
                }

                .moveUp:before,
                .moveUp:after {
                  /*伪元素相同属性提取*/
                  content: '';
                  border-color: transparent;
                  /*边框颜色透明*/
                  border-style: solid;
                  position: absolute;
                  /*绝对定位，分别定位before和after描绘的内容*/
                }

                .moveUp:before {
                  /*伪元素before绘制箭头尾部矩形*/
                  border: none;
                  background: #555;
                  height: 40%;
                  width: 2px;
                  top: 50%;
                  left: 6.5px;
                }

                .moveUp:after {
                  /*伪元素after绘制箭头的头部三角形*/
                  left: 3px;
                  top: -5%;
                  border-width: 5px;
                  border-bottom-color: #555;
                  /*如果绘制向下三角形的话，用border-top-color:#555;*/
                }
              }
            }

            .tr:hover {
              background-color: #303674;
            }
          }
        }
      }
    }

    .otherbot {

      .titlebox,
      .datebox {
        width: 100%;
        height: 40px;
      }

      .contitem {
        width: calc(50% - 20px);
        height: 210px;
        background-color: #fff;
        box-shadow: 2px 3px 6px #fff;
        border-radius: 8px;
        padding: 10px;

        margin: 10px;

        .name {
          font-size: 18px;
          display: flex;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #333;
          line-height: 22px;

          .namepoint {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #3089f8;
            margin: 8px;
            margin-bottom: 15px;
          }
        }

        .stitle {
          color: #e0e0e0;
          font-size: 14px;
          margin-top: 10px;
        }

        .num {
          font-family: Alibaba PuHuiTi;
          font-size: 28px;
          color: #333;

          span {
            color: #e0e0e0;
            font-size: 14px;
            margin: 0 5px;
          }
        }

        .b {
          font-size: 36px;
          padding: 30px 0;
        }

        .detailchart {
          width: calc(100% - 0px);
          height: 150px;
        }

        .wzbox {
          padding-top: 10px;
          width: 100%;
          height: calc(100% - 20px);
          overflow-y: auto;

          .lxywzitem {
            cursor: pointer;
            margin: 5px 0;

            p {
              font-size: 14px;
              color: #fff;
              font-weight: bold;
            }

            .wztimebox {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              color: #ffffff50;

              img {
                margin-right: 10px;
              }
            }
          }

          .lxywzitem:hover {

            p,
            .wztimebox {
              color: #333 !important;
            }
          }
        }
      }
    }

    .hdbox {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 0px;

      .titlebox {
        height: 100%;
        font-size: 22px;
        display: flex;
        width: 100%;
        color: #333;

        .titlepoint {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #3089f8;
          margin: 10px;
        }
      }

      .contitem {
        width: 100%;
        height: 260px;
        background-color: #fff;
        box-shadow: 2px 3px 6px #fff;
        border-radius: 8px;
        padding: 10px;

        margin: 10px 0;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 5px;
    background-color: transparent;
  }

  /*竖直的滑块*/
  ::-webkit-scrollbar-thumb {
    background-color: rgb(20, 61, 107);
    border-radius: 2px;
    border-top: 1px solid rgb(20, 61, 107);
    border-bottom: 1px solid rgb(20, 61, 107);
    border-left: 1px solid rgb(20, 61, 107);
  }
}
</style>
